webpackJsonp([1],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expandSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return collapseSidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(61);


var selectLayersTab = function selectLayersTab(tab) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["c" /* SELECT_LAYERS_TAB */],
    tab: tab
  };
};

var expandSidebar = function expandSidebar() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["d" /* SIDEBAR_EXPAND */]
  };
};

var collapseSidebar = function collapseSidebar() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["e" /* SIDEBAR_COLLAPSE */]
  };
};

var _default = selectLayersTab;
/* harmony default export */ __webpack_exports__["c"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(selectLayersTab, 'selectLayersTab', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/sidebarActions.js');

  __REACT_HOT_LOADER__.register(expandSidebar, 'expandSidebar', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/sidebarActions.js');

  __REACT_HOT_LOADER__.register(collapseSidebar, 'collapseSidebar', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/sidebarActions.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/sidebarActions.js');
}();

;

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_LAYERS; });
/* unused harmony export MOBILE_BREAKPOINT_WIDTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return s3Url; });
// App wide configuration goes here
// import packageJSON from '../../package.json';

// default selected map layer(s) to display when the app loads
var DEFAULT_LAYERS = ['global_aef'];

// mobile width breakpoint
var MOBILE_BREAKPOINT_WIDTH = 420;

// url to assets on S3 bucket
var s3Url = 'https://s3-us-west-2.amazonaws.com/canopyplanet';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DEFAULT_LAYERS, 'DEFAULT_LAYERS', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/config.js');

  __REACT_HOT_LOADER__.register(MOBILE_BREAKPOINT_WIDTH, 'MOBILE_BREAKPOINT_WIDTH', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/config.js');

  __REACT_HOT_LOADER__.register(s3Url, 's3Url', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/config.js');
}();

;

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_AppConnected__ = __webpack_require__(309);






// This component is what allows for integrating Redux with React through the
// react-redux library. Not a whole lot going on here at the moment, but this
// separation is useful when adding React Router later.
var ReduxEntry = function ReduxEntry() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],
    { store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_AppConnected__["a" /* default */], null)
  );
};

var _default = ReduxEntry;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ReduxEntry, 'ReduxEntry', '/Users/gin/ginfo/canopyplanet_expert_map/src/reduxEntry.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/reduxEntry.js');
}();

;

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/ });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "";
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 46);
  /******/
}(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

  var freeGlobal = __webpack_require__(24);

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  module.exports = root;

  /***/
},
/* 1 */
/***/function (module, exports, __webpack_require__) {

  var baseIsNative = __webpack_require__(53),
      getValue = __webpack_require__(59);

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  module.exports = getNative;

  /***/
},
/* 2 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(15);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__src_color__["e"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(132);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(133);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"];
  });

  /***/
},
/* 3 */
/***/function (module, exports) {

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
  }

  module.exports = isObjectLike;

  /***/
},
/* 4 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["c"] = hue;
  /* harmony export (immutable) */__webpack_exports__["b"] = gamma;
  /* harmony export (immutable) */__webpack_exports__["a"] = nogamma;
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(41);

  function linear(a, d) {
    return function (t) {
      return a + t * d;
    };
  }

  function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
      return Math.pow(a + t * b, y);
    };
  }

  function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  }

  function gamma(y) {
    return (y = +y) === 1 ? nogamma : function (a, b) {
      return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
    };
  }

  function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  }

  /***/
},
/* 5 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1);

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');

  module.exports = nativeCreate;

  /***/
},
/* 6 */
/***/function (module, exports, __webpack_require__) {

  var _Symbol = __webpack_require__(11),
      getRawTag = __webpack_require__(55),
      objectToString = __webpack_require__(56);

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  module.exports = baseGetTag;

  /***/
},
/* 7 */
/***/function (module, exports, __webpack_require__) {

  var listCacheClear = __webpack_require__(64),
      listCacheDelete = __webpack_require__(65),
      listCacheGet = __webpack_require__(66),
      listCacheHas = __webpack_require__(67),
      listCacheSet = __webpack_require__(68);

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  module.exports = ListCache;

  /***/
},
/* 8 */
/***/function (module, exports, __webpack_require__) {

  var eq = __webpack_require__(27);

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  module.exports = assocIndexOf;

  /***/
},
/* 9 */
/***/function (module, exports, __webpack_require__) {

  var isKeyable = __webpack_require__(70);

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  module.exports = getMapData;

  /***/
},
/* 10 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony default export */
  __webpack_exports__["a"] = function (a, b) {
    return a = +a, b -= a, function (t) {
      return a + b * t;
    };
  };

  /***/
},
/* 11 */
/***/function (module, exports, __webpack_require__) {

  var root = __webpack_require__(0);

  /** Built-in value references. */
  var _Symbol2 = root.Symbol;

  module.exports = _Symbol2;

  /***/
},
/* 12 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1),
      root = __webpack_require__(0);

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map');

  module.exports = Map;

  /***/
},
/* 13 */
/***/function (module, exports) {

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  module.exports = isArray;

  /***/
},
/* 14 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(39);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(42);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(43);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(10);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(44);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(45);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(41);

  /* harmony default export */__webpack_exports__["a"] = function (a, b) {
    var t = typeof b === 'undefined' ? 'undefined' : _typeof(b),
        c;
    return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b) : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */] : t === "string" ? (c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */] : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */] : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */] : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */] : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
  };

  /***/
},
/* 15 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = Color;
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "d", function () {
    return _darker;
  });
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
    return _brighter;
  });
  /* harmony export (immutable) */__webpack_exports__["e"] = color;
  /* harmony export (immutable) */__webpack_exports__["h"] = rgbConvert;
  /* harmony export (immutable) */__webpack_exports__["g"] = rgb;
  /* harmony export (immutable) */__webpack_exports__["b"] = Rgb;
  /* unused harmony export hslConvert */
  /* harmony export (immutable) */__webpack_exports__["f"] = hsl;
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(16);

  function Color() {}

  var _darker = 0.7;
  var _brighter = 1 / _darker;

  var reI = "\\s*([+-]?\\d+)\\s*",
      reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
      reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
      reHex3 = /^#([0-9a-f]{3})$/,
      reHex6 = /^#([0-9a-f]{6})$/,
      reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
      reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
      reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
      reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
      reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
      reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

  var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
    displayable: function displayable() {
      return this.rgb().displayable();
    },
    toString: function toString() {
      return this.rgb() + "";
    }
  });

  function color(format) {
    var m;
    format = (format + "").trim().toLowerCase();
    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb(m >> 8 & 0xf | m >> 4 & 0x0f0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
    ) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
    : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
    : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
    : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
    : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
    : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
    : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
    : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
  }

  function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
  }

  function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
  }

  function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
  }

  function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
  }

  function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
    brighter: function brighter(k) {
      k = k == null ? _brighter : Math.pow(_brighter, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function darker(k) {
      k = k == null ? _darker : Math.pow(_darker, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function rgb() {
      return this;
    },
    displayable: function displayable() {
      return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
    },
    toString: function toString() {
      var a = this.opacity;a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
      return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
    }
  }));

  function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
  }

  function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        min = Math.min(r, g, b),
        max = Math.max(r, g, b),
        h = NaN,
        s = max - min,
        l = (max + min) / 2;
    if (s) {
      if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
      s /= l < 0.5 ? max + min : 2 - max - min;
      h *= 60;
    } else {
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new Hsl(h, s, l, o.opacity);
  }

  function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
  }

  function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
    brighter: function brighter(k) {
      k = k == null ? _brighter : Math.pow(_brighter, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker(k) {
      k = k == null ? _darker : Math.pow(_darker, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
      var h = this.h % 360 + (this.h < 0) * 360,
          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
          l = this.l,
          m2 = l + (l < 0.5 ? l : 1 - l) * s,
          m1 = 2 * l - m2;
      return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function displayable() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    }
  }));

  /* From FvD 13.37, CSS Color Module Level 3 */
  function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
  }

  /***/
},
/* 16 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["b"] = extend;
  /* harmony default export */__webpack_exports__["a"] = function (constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
  };

  function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for (var key in definition) {
      prototype[key] = definition[key];
    }return prototype;
  }

  /***/
},
/* 17 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = basis;
  function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1,
        t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
  }

  /* harmony default export */__webpack_exports__["b"] = function (values) {
    var n = values.length - 1;
    return function (t) {
      var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
          v1 = values[i],
          v2 = values[i + 1],
          v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
          v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
      return basis((t - i / n) * n, v0, v1, v2, v3);
    };
  };

  /***/
},
/* 18 */
/***/function (module, exports) {

  module.exports = __webpack_require__(3);

  /***/
},
/* 19 */
/***/function (module, exports) {

  module.exports = __webpack_require__(14);

  /***/
},
/* 20 */
/***/function (module, exports) {

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  module.exports = arrayMap;

  /***/
},
/* 21 */
/***/function (module, exports, __webpack_require__) {

  var MapCache = __webpack_require__(22),
      setCacheAdd = __webpack_require__(74),
      setCacheHas = __webpack_require__(75);

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;

  module.exports = SetCache;

  /***/
},
/* 22 */
/***/function (module, exports, __webpack_require__) {

  var mapCacheClear = __webpack_require__(50),
      mapCacheDelete = __webpack_require__(69),
      mapCacheGet = __webpack_require__(71),
      mapCacheHas = __webpack_require__(72),
      mapCacheSet = __webpack_require__(73);

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  module.exports = MapCache;

  /***/
},
/* 23 */
/***/function (module, exports, __webpack_require__) {

  var baseGetTag = __webpack_require__(6),
      isObject = __webpack_require__(25);

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  module.exports = isFunction;

  /***/
},
/* 24 */
/***/function (module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function (global) {
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

    module.exports = freeGlobal;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(54));

  /***/
},
/* 25 */
/***/function (module, exports) {

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    return value != null && (type == 'object' || type == 'function');
  }

  module.exports = isObject;

  /***/
},
/* 26 */
/***/function (module, exports) {

  /** Used for built-in method references. */
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }

  module.exports = toSource;

  /***/
},
/* 27 */
/***/function (module, exports) {

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  module.exports = eq;

  /***/
},
/* 28 */
/***/function (module, exports) {

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  module.exports = baseUnary;

  /***/
},
/* 29 */
/***/function (module, exports) {

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  module.exports = cacheHas;

  /***/
},
/* 30 */
/***/function (module, exports) {

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  module.exports = identity;

  /***/
},
/* 31 */
/***/function (module, exports, __webpack_require__) {

  var isFunction = __webpack_require__(23),
      isLength = __webpack_require__(32);

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  module.exports = isArrayLike;

  /***/
},
/* 32 */
/***/function (module, exports) {

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  module.exports = isLength;

  /***/
},
/* 33 */
/***/function (module, exports, __webpack_require__) {

  var SetCache = __webpack_require__(21),
      arraySome = __webpack_require__(101),
      cacheHas = __webpack_require__(29);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  module.exports = equalArrays;

  /***/
},
/* 34 */
/***/function (module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function (module) {
    var root = __webpack_require__(0),
        stubFalse = __webpack_require__(118);

    /** Detect free variable `exports`. */
    var freeExports = (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Built-in value references. */
    var Buffer = moduleExports ? root.Buffer : undefined;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    module.exports = isBuffer;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(35)(module));

  /***/
},
/* 35 */
/***/function (module, exports) {

  module.exports = function (module) {
    if (!module.webpackPolyfill) {
      module.deprecate = function () {};
      module.paths = [];
      // module.parent = undefined by default
      if (!module.children) module.children = [];
      Object.defineProperty(module, "loaded", {
        enumerable: true,
        get: function get() {
          return module.l;
        }
      });
      Object.defineProperty(module, "id", {
        enumerable: true,
        get: function get() {
          return module.i;
        }
      });
      module.webpackPolyfill = 1;
    }
    return module;
  };

  /***/
},
/* 36 */
/***/function (module, exports, __webpack_require__) {

  var baseIsTypedArray = __webpack_require__(120),
      baseUnary = __webpack_require__(28),
      nodeUtil = __webpack_require__(121);

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  module.exports = isTypedArray;

  /***/
},
/* 37 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(18);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(19);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _d3Interpolate = __webpack_require__(131);

  var _soil_carbon_ = __webpack_require__(144);

  var _soil_carbon_2 = _interopRequireDefault(_soil_carbon_);

  var _mammals_richness_all_ = __webpack_require__(145);

  var _mammals_richness_all_2 = _interopRequireDefault(_mammals_richness_all_);

  var _birds_richness_all_ = __webpack_require__(146);

  var _birds_richness_all_2 = _interopRequireDefault(_birds_richness_all_);

  var _mammals_threatened_ = __webpack_require__(147);

  var _mammals_threatened_2 = _interopRequireDefault(_mammals_threatened_);

  var _birds_threatened_ = __webpack_require__(148);

  var _birds_threatened_2 = _interopRequireDefault(_birds_threatened_);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  /** Renders the legend's contents based on a data layer type */
  var LegendFilling = function LegendFilling(props) {
    var title = props.title,
        dataLayer = props.dataLayer,
        units = props.units,
        unitsLabel = props.unitsLabel,
        unitsLabelSingle = props.unitsLabelSingle,
        fillColor = props.fillColor,
        strokeColor = props.strokeColor;

    var borderStyle = strokeColor ? '1px solid ' + strokeColor : null;

    function renderUnits() {
      return units.map(function (unit) {
        return _react2.default.createElement('p', { className: 'legend-filling__unit', key: unit }, unit, _react2.default.createElement('span', null, unitsLabel));
      });
    }

    function renderUnitSingle() {
      return _react2.default.createElement('p', { className: 'legend-filling__unit' }, unitsLabelSingle);
    }

    function renderTitleAndColorBar() {
      // render the legend title and symbology
      // three different layouts are possible, depending on if the data layer is symbolized with
      // one or more colors. Spreadsheet used to create data_inventory currently only holds one label
      if (dataLayer === 'carbon_density' || dataLayer === 'carbon_density_boreal') {
        // carbon gets a special treatment because it uses a color ramp
        var interpolator = _d3Interpolate.interpolateRgb.gamma(2.2)('rgb(126, 99, 242)', 'rgb(0, 0, 224)');
        var values = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, values.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: 'x-' + i,
            className: 'category category-' + d.v,
            style: { background: interpolator(d) }
          });
        }))];
      }

      // Stella specific layer
      if (dataLayer === 'stella-geocarbon-ind') {
        // carbon gets a special treatment because it uses a color ramp
        var _interpolator = _d3Interpolate.interpolateRgb.gamma(2.2)('rgb(105, 89, 236)', 'rgb(21, 36, 226)');
        var _values = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _values.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: 'x-' + i,
            className: 'category category-' + d.v,
            style: { background: _interpolator(d) }
          });
        }))];
      }

      if (dataLayer === 'global_aef') {
        // Global AEF has two colors
        return _react2.default.createElement('div', null, _react2.default.createElement('div', { className: 'legend-filling__color-square ' + dataLayer + '-1' }), _react2.default.createElement('div', { className: 'legend-filling__color-square ' + dataLayer + '-2' }), _react2.default.createElement('p', { className: 'legend-filling__title', style: { display: 'inline-block' } }, title));
      }

      if (dataLayer === 'treecov_12112019') {
        // treecov gets a special treatment because it uses a color ramp
        var _values2 = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
        var colors = ['rgb(240, 250, 237)', 'rgb(204, 235, 210)', 'rgb(169, 219, 183)', 'rgb(135, 204, 158)', 'rgb(102, 189, 134)', 'rgb(78, 173, 116)', 'rgb(62, 158, 103)', 'rgb(46, 143, 89)', 'rgb(29, 130, 79)', 'rgb(0, 115, 67)'];

        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _values2.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: 'x-' + i,
            className: 'category category-' + d,
            style: { background: colors[i] }
          });
        }))];
      }

      if (dataLayer === 'soil_carbon_02132020') {
        console.log(_soil_carbon_2.default.length);
        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _soil_carbon_2.default.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: d.v,
            className: 'category category-' + d.v,
            style: {
              backgroundColor: 'rgb(' + d.r + ', ' + d.g + ', ' + d.b + ')',
              display: 'inline-block',
              width: 100 / _soil_carbon_2.default.length + '%',
              height: '100%',
              border: 0,
              float: 'left'
            }
          });
        }))];
      }

      if (dataLayer === 'mammals_richness_all_12192019') {
        console.log(_mammals_richness_all_2.default.length);
        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _mammals_richness_all_2.default.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: d.v,
            className: 'category category-' + d.v,
            style: {
              backgroundColor: 'rgb(' + d.r + ', ' + d.g + ', ' + d.b + ')',
              display: 'inline-block',
              width: 100 / _mammals_richness_all_2.default.length + '%',
              height: '100%',
              border: 0,
              float: 'left'
            }
          });
        }))];
      }

      if (dataLayer === 'birds_richness_all_12192019') {
        console.log(_birds_richness_all_2.default.length);
        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _birds_richness_all_2.default.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: d.v,
            className: 'category category-' + d.v,
            style: {
              backgroundColor: 'rgb(' + d.r + ', ' + d.g + ', ' + d.b + ')',
              display: 'inline-block',
              width: 100 / _birds_richness_all_2.default.length + '%',
              height: '100%',
              border: 0,
              float: 'left'
            }
          });
        }))];
      }

      if (dataLayer === 'mammals_threatened_12192019') {
        console.log(_mammals_threatened_2.default.length);
        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _mammals_threatened_2.default.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: d.v,
            className: 'category category-' + d.v,
            style: {
              backgroundColor: 'rgb(' + d.r + ', ' + d.g + ', ' + d.b + ')',
              display: 'inline-block',
              width: 100 / _mammals_threatened_2.default.length + '%',
              height: '100%',
              border: 0,
              float: 'left'
            }
          });
        }))];
      }

      if (dataLayer === 'birds_threatened_12192019') {
        console.log(_birds_threatened_2.default.length);
        return [_react2.default.createElement('p', { key: dataLayer + '-x', className: 'legend-filling__title' }, title), _react2.default.createElement('div', { key: dataLayer + '-y', className: 'legend-filling__color-bar ' + dataLayer }, _birds_threatened_2.default.map(function (d, i) {
          return _react2.default.createElement('div', {
            key: d.v,
            className: 'category category-' + d.v,
            style: {
              backgroundColor: 'rgb(' + d.r + ', ' + d.g + ', ' + d.b + ')',
              display: 'inline-block',
              width: 100 / _birds_threatened_2.default.length + '%',
              height: '100%',
              border: 0,
              float: 'left'
            }
          });
        }))];
      }

      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        className: 'legend-filling__color-square ' + dataLayer,
        style: { background: fillColor, border: borderStyle }
      }), _react2.default.createElement('p', { className: 'legend-filling__title', style: { display: 'inline-block' } }, title));
    }

    return _react2.default.createElement('div', { className: 'LegendFilling' }, renderTitleAndColorBar(), _react2.default.createElement('div', { className: 'legend-filling__units-box' }, renderUnits()), renderUnitSingle());
  };

  LegendFilling.propTypes = {
    title: _propTypes2.default.string.isRequired,
    dataLayer: _propTypes2.default.string.isRequired,
    units: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    unitsLabel: _propTypes2.default.string,
    unitsLabelSingle: _propTypes2.default.string,
    fillColor: _propTypes2.default.string,
    strokeColor: _propTypes2.default.string
  };

  exports.default = LegendFilling;

  /***/
},
/* 38 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return deg2rad;
  });
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
    return rad2deg;
  });
  var deg2rad = Math.PI / 180;
  var rad2deg = 180 / Math.PI;

  /***/
},
/* 39 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return rgbBasis;
  });
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
    return rgbBasisClosed;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(17);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(40);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(4);

  /* harmony default export */__webpack_exports__["a"] = function rgbGamma(y) {
    var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

    function rgb(start, end) {
      var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
          g = color(start.g, end.g),
          b = color(start.b, end.b),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.r = r(t);
        start.g = g(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }

    rgb.gamma = rgbGamma;

    return rgb;
  }(1);

  function rgbSpline(spline) {
    return function (colors) {
      var n = colors.length,
          r = new Array(n),
          g = new Array(n),
          b = new Array(n),
          i,
          color;
      for (i = 0; i < n; ++i) {
        color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
        r[i] = color.r || 0;
        g[i] = color.g || 0;
        b[i] = color.b || 0;
      }
      r = spline(r);
      g = spline(g);
      b = spline(b);
      color.opacity = 1;
      return function (t) {
        color.r = r(t);
        color.g = g(t);
        color.b = b(t);
        return color + "";
      };
    };
  }

  var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
  var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);

  /***/
},
/* 40 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(17);

  /* harmony default export */__webpack_exports__["a"] = function (values) {
    var n = values.length;
    return function (t) {
      var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
          v0 = values[(i + n - 1) % n],
          v1 = values[i % n],
          v2 = values[(i + 1) % n],
          v3 = values[(i + 2) % n];
      return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
    };
  };

  /***/
},
/* 41 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony default export */
  __webpack_exports__["a"] = function (x) {
    return function () {
      return x;
    };
  };

  /***/
},
/* 42 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(14);

  /* harmony default export */__webpack_exports__["a"] = function (a, b) {
    var nb = b ? b.length : 0,
        na = a ? Math.min(nb, a.length) : 0,
        x = new Array(nb),
        c = new Array(nb),
        i;

    for (i = 0; i < na; ++i) {
      x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
    }for (; i < nb; ++i) {
      c[i] = b[i];
    }return function (t) {
      for (i = 0; i < na; ++i) {
        c[i] = x[i](t);
      }return c;
    };
  };

  /***/
},
/* 43 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony default export */
  __webpack_exports__["a"] = function (a, b) {
    var d = new Date();
    return a = +a, b -= a, function (t) {
      return d.setTime(a + b * t), d;
    };
  };

  /***/
},
/* 44 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(14);

  /* harmony default export */__webpack_exports__["a"] = function (a, b) {
    var i = {},
        c = {},
        k;

    if (a === null || (typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== "object") a = {};
    if (b === null || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) !== "object") b = {};

    for (k in b) {
      if (k in a) {
        i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
      } else {
        c[k] = b[k];
      }
    }

    return function (t) {
      for (k in i) {
        c[k] = i[k](t);
      }return c;
    };
  };

  /***/
},
/* 45 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony import */
  var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(10);

  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      reB = new RegExp(reA.source, "g");

  function zero(b) {
    return function () {
      return b;
    };
  }

  function one(b) {
    return function (t) {
      return b(t) + "";
    };
  }

  /* harmony default export */__webpack_exports__["a"] = function (a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0,
        // scan index for next number in b
    am,
        // current match in a
    bm,
        // current match in b
    bs,
        // string preceding current number in b, if any
    i = -1,
        // index in s
    s = [],
        // string constants and placeholders
    q = []; // number interpolators

    // Coerce inputs to strings.
    a = a + "", b = b + "";

    // Interpolate pairs of numbers in a & b.
    while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
      if ((bs = bm.index) > bi) {
        // a string precedes the next number in b
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        // numbers in a & b match
        if (s[i]) s[i] += bm; // coalesce with previous string
        else s[++i] = bm;
      } else {
        // interpolate non-matching numbers
        s[++i] = null;
        q.push({ i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm) });
      }
      bi = reB.lastIndex;
    }

    // Add remains of b.
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }

    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
      for (var i = 0, o; i < b; ++i) {
        s[(o = q[i]).i] = o.x(t);
      }return s.join("");
    });
  };

  /***/
},
/* 46 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.LegendFilling = undefined;

  var _MapLegend = __webpack_require__(47);

  var _MapLegend2 = _interopRequireDefault(_MapLegend);

  var _MapLegendFilling = __webpack_require__(37);

  var _MapLegendFilling2 = _interopRequireDefault(_MapLegendFilling);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  exports.default = _MapLegend2.default;
  exports.LegendFilling = _MapLegendFilling2.default;

  /***/
},
/* 47 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
    }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
  }();

  var _react = __webpack_require__(18);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes = __webpack_require__(19);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _intersection = __webpack_require__(48);

  var _intersection2 = _interopRequireDefault(_intersection);

  var _isEqual = __webpack_require__(92);

  var _isEqual2 = _interopRequireDefault(_isEqual);

  var _MapLegendFilling = __webpack_require__(37);

  var _MapLegendFilling2 = _interopRequireDefault(_MapLegendFilling);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /** Class for the map legend */
  var MapLegend = function (_Component) {
    _inherits(MapLegend, _Component);

    function MapLegend(props) {
      _classCallCheck(this, MapLegend);

      var _this = _possibleConstructorReturn(this, (MapLegend.__proto__ || Object.getPrototypeOf(MapLegend)).call(this, props));

      var width = props.width,
          mapDataLayers = props.mapDataLayers;

      _this.state = { open: width >= 420 };
      // create an array of datacodes which represent
      // the only data layer names we care about when rendering a legend
      _this.layerNamesPreferred = Object.values(mapDataLayers).reduce(function (arr, layer) {
        if (layer.display_legend === 'yes') {
          return [].concat(_toConsumableArray(arr), [layer.datacode]);
        }
        return arr;
      }, []);
      _this.handleClick = _this.handleClick.bind(_this);
      return _this;
    }

    _createClass(MapLegend, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        var width = nextProps.width,
            activeLayers = nextProps.activeLayers;
        var open = nextState.open;

        if (width !== this.props.width || !(0, _isEqual2.default)(activeLayers, this.props.activeLayers) || open !== this.state.open) {
          return true;
        }

        return false;
      }
    }, {
      key: "handleClick",
      value: function handleClick() {
        this.setState({ open: !this.state.open });
      }

      // eslint-disable-next-line class-methods-use-this

    }, {
      key: "renderLegendContents",
      value: function renderLegendContents(matched) {
        // returns separate legend fillings for each matched legend item
        var mapDataLayers = this.props.mapDataLayers;

        return matched.map(function (layer) {
          var dataLayer = mapDataLayers[layer];
          var datacode = dataLayer.datacode,
              layerlabel = dataLayer.layerlabel,
              legend_units = dataLayer.legend_units,
              legend_units_label = dataLayer.legend_units_label,
              legend_units_label_single = dataLayer.legend_units_label_single,
              legend_fill = dataLayer.legend_fill,
              style = dataLayer.style;
          // if there's a style property and a color, pass it to the legend filling to add a
          // border with that very same color to the square filled area

          var strokeColor = style && style.color ? style.color : null;

          return _react2.default.createElement(_MapLegendFilling2.default, {
            key: datacode,
            title: layerlabel,
            dataLayer: datacode,
            units: legend_units || [],
            unitsLabelSingle: legend_units_label_single,
            unitsLabel: legend_units_label,
            fillColor: legend_fill,
            strokeColor: strokeColor
          });
        });
      }
    }, {
      key: "renderMapLegend",
      value: function renderMapLegend() {
        var _props = this.props,
            activeLayers = _props.activeLayers,
            mapDataLayers = _props.mapDataLayers;
        var open = this.state.open;

        var matched = (0, _intersection2.default)(this.layerNamesPreferred, activeLayers);

        return _react2.default.createElement("div", { className: open ? "MapLegend" : "MapLegend closed" }, _react2.default.createElement("div", { style: { display: open ? "block" : "none" } }, _react2.default.createElement("button", { className: "map-legend__close", onClick: this.handleClick }, _react2.default.createElement("i", { className: "icon material-icons" }, "close"), _react2.default.createElement("span", { className: "sr" }, "Close")), this.renderLegendContents(matched), _react2.default.createElement("div", {
          className: matched.length ? "basemap-credits" : "basemap-credits no-border"
        }, _react2.default.createElement("p", null, "Map tiles by ", _react2.default.createElement("a", { href: "http://stamen.com" }, "Stamen Design"), ", under", _react2.default.createElement("a", { href: "http://creativecommons.org/licenses/by/3.0" }, " ", "CC BY 3.0"), ". Data by ", _react2.default.createElement("a", { href: "http://openstreetmap.org" }, "OpenStreetMap"), ", under", " ", _react2.default.createElement("a", { href: "http://www.openstreetmap.org/copyright" }, "ODbL"), "."))), _react2.default.createElement("button", {
          className: "map-legend__open",
          onClick: this.handleClick,
          style: { display: open ? "none" : "block" }
        }, _react2.default.createElement("i", { className: "icon material-icons" }, "info_outline"), _react2.default.createElement("span", { className: "sr" }, "Open")));
      }
    }, {
      key: "render",
      value: function render() {
        return this.renderMapLegend();
      }
    }]);

    return MapLegend;
  }(_react.Component);

  MapLegend.propTypes = {
    activeLayers: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired, // which layers are currently active?
    mapDataLayers: _propTypes2.default.shape({
      datacode: _propTypes2.default.string,
      layerlabel: _propTypes2.default.string,
      legend_units: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.number), _propTypes2.default.arrayOf(_propTypes2.default.string)]),
      legend_units_label_single: _propTypes2.default.string,
      legend_fill: _propTypes2.default.string,
      style: _propTypes2.default.shape({
        color: _propTypes2.default.string
      })
    }).isRequired, // hash of all data layers with expected properties
    width: _propTypes2.default.number
  };
  MapLegend.defaultProps = {
    width: 0,
    activeLayers: [],
    mapDataLayers: {}
  };
  exports.default = MapLegend;

  /***/
},
/* 48 */
/***/function (module, exports, __webpack_require__) {

  var arrayMap = __webpack_require__(20),
      baseIntersection = __webpack_require__(49),
      baseRest = __webpack_require__(82),
      castArrayLikeObject = __webpack_require__(90);

  /**
   * Creates an array of unique values that are included in all given arrays
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons. The order and references of result values are
   * determined by the first array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {...Array} [arrays] The arrays to inspect.
   * @returns {Array} Returns the new array of intersecting values.
   * @example
   *
   * _.intersection([2, 1], [2, 3]);
   * // => [2]
   */
  var intersection = baseRest(function (arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
  });

  module.exports = intersection;

  /***/
},
/* 49 */
/***/function (module, exports, __webpack_require__) {

  var SetCache = __webpack_require__(21),
      arrayIncludes = __webpack_require__(76),
      arrayIncludesWith = __webpack_require__(81),
      arrayMap = __webpack_require__(20),
      baseUnary = __webpack_require__(28),
      cacheHas = __webpack_require__(29);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMin = Math.min;

  /**
   * The base implementation of methods like `_.intersection`, without support
   * for iteratee shorthands, that accepts an array of arrays to inspect.
   *
   * @private
   * @param {Array} arrays The arrays to inspect.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of shared values.
   */
  function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes,
        length = arrays[0].length,
        othLength = arrays.length,
        othIndex = othLength,
        caches = Array(othLength),
        maxLength = Infinity,
        result = [];

    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee) {
        array = arrayMap(array, baseUnary(iteratee));
      }
      maxLength = nativeMin(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];

    var index = -1,
        seen = caches[0];

    outer: while (++index < length && result.length < maxLength) {
      var value = array[index],
          computed = iteratee ? iteratee(value) : value;

      value = comparator || value !== 0 ? value : 0;
      if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
        othIndex = othLength;
        while (--othIndex) {
          var cache = caches[othIndex];
          if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
            continue outer;
          }
        }
        if (seen) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    return result;
  }

  module.exports = baseIntersection;

  /***/
},
/* 50 */
/***/function (module, exports, __webpack_require__) {

  var Hash = __webpack_require__(51),
      ListCache = __webpack_require__(7),
      Map = __webpack_require__(12);

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }

  module.exports = mapCacheClear;

  /***/
},
/* 51 */
/***/function (module, exports, __webpack_require__) {

  var hashClear = __webpack_require__(52),
      hashDelete = __webpack_require__(60),
      hashGet = __webpack_require__(61),
      hashHas = __webpack_require__(62),
      hashSet = __webpack_require__(63);

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  module.exports = Hash;

  /***/
},
/* 52 */
/***/function (module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(5);

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  module.exports = hashClear;

  /***/
},
/* 53 */
/***/function (module, exports, __webpack_require__) {

  var isFunction = __webpack_require__(23),
      isMasked = __webpack_require__(57),
      isObject = __webpack_require__(25),
      toSource = __webpack_require__(26);

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  module.exports = baseIsNative;

  /***/
},
/* 54 */
/***/function (module, exports) {

  var g;

  // This works in non-strict mode
  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object") g = window;
  }

  // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}

  module.exports = g;

  /***/
},
/* 55 */
/***/function (module, exports, __webpack_require__) {

  var _Symbol3 = __webpack_require__(11);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol3 ? _Symbol3.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  module.exports = getRawTag;

  /***/
},
/* 56 */
/***/function (module, exports) {

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  module.exports = objectToString;

  /***/
},
/* 57 */
/***/function (module, exports, __webpack_require__) {

  var coreJsData = __webpack_require__(58);

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  module.exports = isMasked;

  /***/
},
/* 58 */
/***/function (module, exports, __webpack_require__) {

  var root = __webpack_require__(0);

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  module.exports = coreJsData;

  /***/
},
/* 59 */
/***/function (module, exports) {

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  module.exports = getValue;

  /***/
},
/* 60 */
/***/function (module, exports) {

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = hashDelete;

  /***/
},
/* 61 */
/***/function (module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(5);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  module.exports = hashGet;

  /***/
},
/* 62 */
/***/function (module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(5);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  module.exports = hashHas;

  /***/
},
/* 63 */
/***/function (module, exports, __webpack_require__) {

  var nativeCreate = __webpack_require__(5);

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }

  module.exports = hashSet;

  /***/
},
/* 64 */
/***/function (module, exports) {

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  module.exports = listCacheClear;

  /***/
},
/* 65 */
/***/function (module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(8);

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  module.exports = listCacheDelete;

  /***/
},
/* 66 */
/***/function (module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(8);

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  module.exports = listCacheGet;

  /***/
},
/* 67 */
/***/function (module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(8);

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  module.exports = listCacheHas;

  /***/
},
/* 68 */
/***/function (module, exports, __webpack_require__) {

  var assocIndexOf = __webpack_require__(8);

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  module.exports = listCacheSet;

  /***/
},
/* 69 */
/***/function (module, exports, __webpack_require__) {

  var getMapData = __webpack_require__(9);

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  module.exports = mapCacheDelete;

  /***/
},
/* 70 */
/***/function (module, exports) {

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  module.exports = isKeyable;

  /***/
},
/* 71 */
/***/function (module, exports, __webpack_require__) {

  var getMapData = __webpack_require__(9);

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  module.exports = mapCacheGet;

  /***/
},
/* 72 */
/***/function (module, exports, __webpack_require__) {

  var getMapData = __webpack_require__(9);

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  module.exports = mapCacheHas;

  /***/
},
/* 73 */
/***/function (module, exports, __webpack_require__) {

  var getMapData = __webpack_require__(9);

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  module.exports = mapCacheSet;

  /***/
},
/* 74 */
/***/function (module, exports) {

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }

  module.exports = setCacheAdd;

  /***/
},
/* 75 */
/***/function (module, exports) {

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  module.exports = setCacheHas;

  /***/
},
/* 76 */
/***/function (module, exports, __webpack_require__) {

  var baseIndexOf = __webpack_require__(77);

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  module.exports = arrayIncludes;

  /***/
},
/* 77 */
/***/function (module, exports, __webpack_require__) {

  var baseFindIndex = __webpack_require__(78),
      baseIsNaN = __webpack_require__(79),
      strictIndexOf = __webpack_require__(80);

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  module.exports = baseIndexOf;

  /***/
},
/* 78 */
/***/function (module, exports) {

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  module.exports = baseFindIndex;

  /***/
},
/* 79 */
/***/function (module, exports) {

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  module.exports = baseIsNaN;

  /***/
},
/* 80 */
/***/function (module, exports) {

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  module.exports = strictIndexOf;

  /***/
},
/* 81 */
/***/function (module, exports) {

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  module.exports = arrayIncludesWith;

  /***/
},
/* 82 */
/***/function (module, exports, __webpack_require__) {

  var identity = __webpack_require__(30),
      overRest = __webpack_require__(83),
      setToString = __webpack_require__(85);

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  module.exports = baseRest;

  /***/
},
/* 83 */
/***/function (module, exports, __webpack_require__) {

  var apply = __webpack_require__(84);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }

  module.exports = overRest;

  /***/
},
/* 84 */
/***/function (module, exports) {

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  module.exports = apply;

  /***/
},
/* 85 */
/***/function (module, exports, __webpack_require__) {

  var baseSetToString = __webpack_require__(86),
      shortOut = __webpack_require__(89);

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);

  module.exports = setToString;

  /***/
},
/* 86 */
/***/function (module, exports, __webpack_require__) {

  var constant = __webpack_require__(87),
      defineProperty = __webpack_require__(88),
      identity = __webpack_require__(30);

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };

  module.exports = baseSetToString;

  /***/
},
/* 87 */
/***/function (module, exports) {

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function () {
      return value;
    };
  }

  module.exports = constant;

  /***/
},
/* 88 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1);

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();

  module.exports = defineProperty;

  /***/
},
/* 89 */
/***/function (module, exports) {

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
        lastCalled = 0;

    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }

  module.exports = shortOut;

  /***/
},
/* 90 */
/***/function (module, exports, __webpack_require__) {

  var isArrayLikeObject = __webpack_require__(91);

  /**
   * Casts `value` to an empty array if it's not an array like object.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array|Object} Returns the cast array-like object.
   */
  function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
  }

  module.exports = castArrayLikeObject;

  /***/
},
/* 91 */
/***/function (module, exports, __webpack_require__) {

  var isArrayLike = __webpack_require__(31),
      isObjectLike = __webpack_require__(3);

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  module.exports = isArrayLikeObject;

  /***/
},
/* 92 */
/***/function (module, exports, __webpack_require__) {

  var baseIsEqual = __webpack_require__(93);

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  module.exports = isEqual;

  /***/
},
/* 93 */
/***/function (module, exports, __webpack_require__) {

  var baseIsEqualDeep = __webpack_require__(94),
      isObjectLike = __webpack_require__(3);

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  module.exports = baseIsEqual;

  /***/
},
/* 94 */
/***/function (module, exports, __webpack_require__) {

  var Stack = __webpack_require__(95),
      equalArrays = __webpack_require__(33),
      equalByTag = __webpack_require__(102),
      equalObjects = __webpack_require__(106),
      getTag = __webpack_require__(126),
      isArray = __webpack_require__(13),
      isBuffer = __webpack_require__(34),
      isTypedArray = __webpack_require__(36);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      objectTag = '[object Object]';

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);

    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;

    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  module.exports = baseIsEqualDeep;

  /***/
},
/* 95 */
/***/function (module, exports, __webpack_require__) {

  var ListCache = __webpack_require__(7),
      stackClear = __webpack_require__(96),
      stackDelete = __webpack_require__(97),
      stackGet = __webpack_require__(98),
      stackHas = __webpack_require__(99),
      stackSet = __webpack_require__(100);

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  module.exports = Stack;

  /***/
},
/* 96 */
/***/function (module, exports, __webpack_require__) {

  var ListCache = __webpack_require__(7);

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  module.exports = stackClear;

  /***/
},
/* 97 */
/***/function (module, exports) {

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  module.exports = stackDelete;

  /***/
},
/* 98 */
/***/function (module, exports) {

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  module.exports = stackGet;

  /***/
},
/* 99 */
/***/function (module, exports) {

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  module.exports = stackHas;

  /***/
},
/* 100 */
/***/function (module, exports, __webpack_require__) {

  var ListCache = __webpack_require__(7),
      Map = __webpack_require__(12),
      MapCache = __webpack_require__(22);

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  module.exports = stackSet;

  /***/
},
/* 101 */
/***/function (module, exports) {

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  module.exports = arraySome;

  /***/
},
/* 102 */
/***/function (module, exports, __webpack_require__) {

  var _Symbol4 = __webpack_require__(11),
      Uint8Array = __webpack_require__(103),
      eq = __webpack_require__(27),
      equalArrays = __webpack_require__(33),
      mapToArray = __webpack_require__(104),
      setToArray = __webpack_require__(105);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol4 ? _Symbol4.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  module.exports = equalByTag;

  /***/
},
/* 103 */
/***/function (module, exports, __webpack_require__) {

  var root = __webpack_require__(0);

  /** Built-in value references. */
  var Uint8Array = root.Uint8Array;

  module.exports = Uint8Array;

  /***/
},
/* 104 */
/***/function (module, exports) {

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  module.exports = mapToArray;

  /***/
},
/* 105 */
/***/function (module, exports) {

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  module.exports = setToArray;

  /***/
},
/* 106 */
/***/function (module, exports, __webpack_require__) {

  var getAllKeys = __webpack_require__(107);

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  module.exports = equalObjects;

  /***/
},
/* 107 */
/***/function (module, exports, __webpack_require__) {

  var baseGetAllKeys = __webpack_require__(108),
      getSymbols = __webpack_require__(110),
      keys = __webpack_require__(113);

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }

  module.exports = getAllKeys;

  /***/
},
/* 108 */
/***/function (module, exports, __webpack_require__) {

  var arrayPush = __webpack_require__(109),
      isArray = __webpack_require__(13);

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  module.exports = baseGetAllKeys;

  /***/
},
/* 109 */
/***/function (module, exports) {

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  module.exports = arrayPush;

  /***/
},
/* 110 */
/***/function (module, exports, __webpack_require__) {

  var arrayFilter = __webpack_require__(111),
      stubArray = __webpack_require__(112);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };

  module.exports = getSymbols;

  /***/
},
/* 111 */
/***/function (module, exports) {

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  module.exports = arrayFilter;

  /***/
},
/* 112 */
/***/function (module, exports) {

  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  module.exports = stubArray;

  /***/
},
/* 113 */
/***/function (module, exports, __webpack_require__) {

  var arrayLikeKeys = __webpack_require__(114),
      baseKeys = __webpack_require__(122),
      isArrayLike = __webpack_require__(31);

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  module.exports = keys;

  /***/
},
/* 114 */
/***/function (module, exports, __webpack_require__) {

  var baseTimes = __webpack_require__(115),
      isArguments = __webpack_require__(116),
      isArray = __webpack_require__(13),
      isBuffer = __webpack_require__(34),
      isIndex = __webpack_require__(119),
      isTypedArray = __webpack_require__(36);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }

  module.exports = arrayLikeKeys;

  /***/
},
/* 115 */
/***/function (module, exports) {

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  module.exports = baseTimes;

  /***/
},
/* 116 */
/***/function (module, exports, __webpack_require__) {

  var baseIsArguments = __webpack_require__(117),
      isObjectLike = __webpack_require__(3);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };

  module.exports = isArguments;

  /***/
},
/* 117 */
/***/function (module, exports, __webpack_require__) {

  var baseGetTag = __webpack_require__(6),
      isObjectLike = __webpack_require__(3);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  module.exports = baseIsArguments;

  /***/
},
/* 118 */
/***/function (module, exports) {

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = stubFalse;

  /***/
},
/* 119 */
/***/function (module, exports) {

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  module.exports = isIndex;

  /***/
},
/* 120 */
/***/function (module, exports, __webpack_require__) {

  var baseGetTag = __webpack_require__(6),
      isLength = __webpack_require__(32),
      isObjectLike = __webpack_require__(3);

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  module.exports = baseIsTypedArray;

  /***/
},
/* 121 */
/***/function (module, exports, __webpack_require__) {

  /* WEBPACK VAR INJECTION */(function (module) {
    var freeGlobal = __webpack_require__(24);

    /** Detect free variable `exports`. */
    var freeExports = (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    module.exports = nodeUtil;

    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(35)(module));

  /***/
},
/* 122 */
/***/function (module, exports, __webpack_require__) {

  var isPrototype = __webpack_require__(123),
      nativeKeys = __webpack_require__(124);

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  module.exports = baseKeys;

  /***/
},
/* 123 */
/***/function (module, exports) {

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

    return value === proto;
  }

  module.exports = isPrototype;

  /***/
},
/* 124 */
/***/function (module, exports, __webpack_require__) {

  var overArg = __webpack_require__(125);

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);

  module.exports = nativeKeys;

  /***/
},
/* 125 */
/***/function (module, exports) {

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  module.exports = overArg;

  /***/
},
/* 126 */
/***/function (module, exports, __webpack_require__) {

  var DataView = __webpack_require__(127),
      Map = __webpack_require__(12),
      Promise = __webpack_require__(128),
      Set = __webpack_require__(129),
      WeakMap = __webpack_require__(130),
      baseGetTag = __webpack_require__(6),
      toSource = __webpack_require__(26);

  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';

  var dataViewTag = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }

  module.exports = getTag;

  /***/
},
/* 127 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1),
      root = __webpack_require__(0);

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root, 'DataView');

  module.exports = DataView;

  /***/
},
/* 128 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1),
      root = __webpack_require__(0);

  /* Built-in method references that are verified to be native. */
  var Promise = getNative(root, 'Promise');

  module.exports = Promise;

  /***/
},
/* 129 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1),
      root = __webpack_require__(0);

  /* Built-in method references that are verified to be native. */
  var Set = getNative(root, 'Set');

  module.exports = Set;

  /***/
},
/* 130 */
/***/function (module, exports, __webpack_require__) {

  var getNative = __webpack_require__(1),
      root = __webpack_require__(0);

  /* Built-in method references that are verified to be native. */
  var WeakMap = getNative(root, 'WeakMap');

  module.exports = WeakMap;

  /***/
},
/* 131 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(14);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolate", function () {
    return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(42);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateArray", function () {
    return __WEBPACK_IMPORTED_MODULE_1__src_array__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(17);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateBasis", function () {
    return __WEBPACK_IMPORTED_MODULE_2__src_basis__["b"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(40);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function () {
    return __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(43);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateDate", function () {
    return __WEBPACK_IMPORTED_MODULE_4__src_date__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(10);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateNumber", function () {
    return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(44);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateObject", function () {
    return __WEBPACK_IMPORTED_MODULE_6__src_object__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(134);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateRound", function () {
    return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(45);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateString", function () {
    return __WEBPACK_IMPORTED_MODULE_8__src_string__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(135);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function () {
    return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["a"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function () {
    return __WEBPACK_IMPORTED_MODULE_9__src_transform_index__["b"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(138);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateZoom", function () {
    return __WEBPACK_IMPORTED_MODULE_10__src_zoom__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(39);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateRgb", function () {
    return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["a"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function () {
    return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["b"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function () {
    return __WEBPACK_IMPORTED_MODULE_11__src_rgb__["c"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(139);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateHsl", function () {
    return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["a"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateHslLong", function () {
    return __WEBPACK_IMPORTED_MODULE_12__src_hsl__["b"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(140);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateLab", function () {
    return __WEBPACK_IMPORTED_MODULE_13__src_lab__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(141);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateHcl", function () {
    return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["a"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateHclLong", function () {
    return __WEBPACK_IMPORTED_MODULE_14__src_hcl__["b"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(142);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function () {
    return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["b"];
  });
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function () {
    return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"];
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(143);
  /* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "quantize", function () {
    return __WEBPACK_IMPORTED_MODULE_16__src_quantize__["a"];
  });

  /***/
},
/* 132 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = lab;
  /* unused harmony export Lab */
  /* harmony export (immutable) */__webpack_exports__["b"] = hcl;
  /* unused harmony export Hcl */
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(16);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(38);

  var Kn = 18,
      Xn = 0.950470,
      // D65 standard referent
  Yn = 1,
      Zn = 1.088830,
      t0 = 4 / 29,
      t1 = 6 / 29,
      t2 = 3 * t1 * t1,
      t3 = t1 * t1 * t1;

  function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) {
      var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
      return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
    var b = rgb2xyz(o.r),
        a = rgb2xyz(o.g),
        l = rgb2xyz(o.b),
        x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
        y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
        z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
  }

  function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
  }

  function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
    brighter: function brighter(k) {
      return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function darker(k) {
      return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function rgb() {
      var y = (this.l + 16) / 116,
          x = isNaN(this.a) ? y : y + this.a / 500,
          z = isNaN(this.b) ? y : y - this.b / 200;
      y = Yn * lab2xyz(y);
      x = Xn * lab2xyz(x);
      z = Zn * lab2xyz(z);
      return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z), xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), this.opacity);
    }
  }));

  function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
  }

  function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
  }

  function xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
  }

  function rgb2xyz(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  }

  function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
  }

  function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
  }

  function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
    brighter: function brighter(k) {
      return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
    },
    darker: function darker(k) {
      return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
    },
    rgb: function rgb() {
      return labConvert(this).rgb();
    }
  }));

  /***/
},
/* 133 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = cubehelix;
  /* unused harmony export Cubehelix */
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(16);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(15);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(38);

  var A = -0.14861,
      B = +1.78277,
      C = -0.29227,
      D = -0.90649,
      E = +1.97294,
      ED = E * D,
      EB = E * B,
      BC_DA = B * C - D * A;

  function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
        bl = b - l,
        k = (E * (g - l) - C * bl) / D,
        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
        // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
  }

  function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
  }

  function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
    brighter: function brighter(k) {
      k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker(k) {
      k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
      var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
          l = +this.l,
          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
          cosh = Math.cos(h),
          sinh = Math.sin(h);
      return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
  }));

  /***/
},
/* 134 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony default export */
  __webpack_exports__["a"] = function (a, b) {
    return a = +a, b -= a, function (t) {
      return Math.round(a + b * t);
    };
  };

  /***/
},
/* 135 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return interpolateTransformCss;
  });
  /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
    return interpolateTransformSvg;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(10);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(136);

  function interpolateTransform(parse, pxComma, pxParen, degParen) {

    function pop(s) {
      return s.length ? s.pop() + " " : "";
    }

    function translate(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push("translate(", null, pxComma, null, pxParen);
        q.push({ i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb) }, { i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb) });
      } else if (xb || yb) {
        s.push("translate(" + xb + pxComma + yb + pxParen);
      }
    }

    function rotate(a, b, s, q) {
      if (a !== b) {
        if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path
        q.push({ i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b) });
      } else if (b) {
        s.push(pop(s) + "rotate(" + b + degParen);
      }
    }

    function skewX(a, b, s, q) {
      if (a !== b) {
        q.push({ i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b) });
      } else if (b) {
        s.push(pop(s) + "skewX(" + b + degParen);
      }
    }

    function scale(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push(pop(s) + "scale(", null, ",", null, ")");
        q.push({ i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb) }, { i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb) });
      } else if (xb !== 1 || yb !== 1) {
        s.push(pop(s) + "scale(" + xb + "," + yb + ")");
      }
    }

    return function (a, b) {
      var s = [],
          // string constants and placeholders
      q = []; // number interpolators
      a = parse(a), b = parse(b);
      translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
      rotate(a.rotate, b.rotate, s, q);
      skewX(a.skewX, b.skewX, s, q);
      scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
      a = b = null; // gc
      return function (t) {
        var i = -1,
            n = q.length,
            o;
        while (++i < n) {
          s[(o = q[i]).i] = o.x(t);
        }return s.join("");
      };
    };
  }

  var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
  var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");

  /***/
},
/* 136 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = parseCss;
  /* harmony export (immutable) */__webpack_exports__["b"] = parseSvg;
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(137);

  var cssNode, cssRoot, cssView, svgNode;

  function parseCss(value) {
    if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
    cssNode.style.transform = value;
    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
    cssRoot.removeChild(cssNode);
    value = value.slice(7, -1).split(",");
    return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
  }

  function parseSvg(value) {
    if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
    value = value.matrix;
    return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
  }

  /***/
},
/* 137 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return identity;
  });
  var degrees = 180 / Math.PI;

  var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
  };

  /* harmony default export */__webpack_exports__["a"] = function (a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
      translateX: e,
      translateY: f,
      rotate: Math.atan2(b, a) * degrees,
      skewX: Math.atan(skewX) * degrees,
      scaleX: scaleX,
      scaleY: scaleY
    };
  };

  /***/
},
/* 138 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";

  var rho = Math.SQRT2,
      rho2 = 2,
      rho4 = 4,
      epsilon2 = 1e-12;

  function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }

  function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }

  function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }

  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  /* harmony default export */__webpack_exports__["a"] = function (p0, p1) {
    var ux0 = p0[0],
        uy0 = p0[1],
        w0 = p0[2],
        ux1 = p1[0],
        uy1 = p1[1],
        w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S;

    // Special case for u0 ≅ u1.
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function i(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    }

    // General case.
    else {
        var d1 = Math.sqrt(d2),
            b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
            b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
            r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
            r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / rho;
        i = function i(t) {
          var s = t * S,
              coshr0 = cosh(r0),
              u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
          return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
        };
      }

    i.duration = S * 1000;

    return i;
  };

  /***/
},
/* 139 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return hslLong;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(4);

  function hsl(hue) {
    return function (start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    };
  }

  /* harmony default export */__webpack_exports__["a"] = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]);
  var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

  /***/
},
/* 140 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (immutable) */
  __webpack_exports__["a"] = lab;
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(4);

  function lab(start, end) {
    var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
        a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
        b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.l = l(t);
      start.a = a(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  /***/
},
/* 141 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "b", function () {
    return hclLong;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(4);

  function hcl(hue) {
    return function (start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
          c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.c = c(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    };
  }

  /* harmony default export */__webpack_exports__["a"] = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]);
  var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

  /***/
},
/* 142 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony export (binding) */
  __webpack_require__.d(__webpack_exports__, "a", function () {
    return cubehelixLong;
  });
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(2);
  /* harmony import */var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(4);

  function cubehelix(hue) {
    return function cubehelixGamma(y) {
      y = +y;

      function cubehelix(start, end) {
        var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
            s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
            l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
            opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
        return function (t) {
          start.h = h(t);
          start.s = s(t);
          start.l = l(Math.pow(t, y));
          start.opacity = opacity(t);
          return start + "";
        };
      }

      cubehelix.gamma = cubehelixGamma;

      return cubehelix;
    }(1);
  }

  /* harmony default export */__webpack_exports__["b"] = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]);
  var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);

  /***/
},
/* 143 */
/***/function (module, __webpack_exports__, __webpack_require__) {

  "use strict";
  /* harmony default export */
  __webpack_exports__["a"] = function (interpolator, n) {
    var samples = new Array(n);
    for (var i = 0; i < n; ++i) {
      samples[i] = interpolator(i / (n - 1));
    }return samples;
  };

  /***/
},
/* 144 */
/***/function (module, exports) {

  module.exports = [{ "v": "0", "r": 222, "g": 206, "b": 186 }, { "v": "20", "r": 214, "g": 195, "b": 171 }, { "v": "40", "r": 207, "g": 184, "b": 157 }, { "v": "60", "r": 201, "g": 175, "b": 143 }, { "v": "80", "r": 194, "g": 166, "b": 130 }, { "v": "100", "r": 186, "g": 155, "b": 115 }, { "v": "120", "r": 179, "g": 146, "b": 104 }, { "v": "140", "r": 171, "g": 139, "b": 97 }, { "v": "160", "r": 166, "g": 133, "b": 91 }, { "v": "180", "r": 158, "g": 126, "b": 84 }, { "v": "200", "r": 153, "g": 122, "b": 80 }, { "v": "220", "r": 145, "g": 115, "b": 73 }, { "v": "240", "r": 140, "g": 110, "b": 67 }, { "v": "260", "r": 133, "g": 102, "b": 62 }, { "v": "280", "r": 125, "g": 95, "b": 56 }, { "v": "300", "r": 117, "g": 88, "b": 50 }, { "v": "320", "r": 110, "g": 81, "b": 44 }, { "v": "340", "r": 102, "g": 75, "b": 40 }, { "v": "360", "r": 97, "g": 70, "b": 35 }, { "v": "380", "r": 87, "g": 62, "b": 29 }, { "v": "400", "r": 74, "g": 51, "b": 21 }, { "v": "420", "r": 64, "g": 43, "b": 16 }, { "v": "440", "r": 54, "g": 35, "b": 11 }, { "v": "460", "r": 43, "g": 28, "b": 7 }, { "v": "480", "r": 33, "g": 21, "b": 4 }];

  /***/
},
/* 145 */
/***/function (module, exports) {

  module.exports = [{ "v": "0", "r": 240, "g": 219, "b": 194 }, { "v": "10", "r": 242, "g": 224, "b": 182 }, { "v": "19", "r": 247, "g": 232, "b": 168 }, { "v": "28", "r": 250, "g": 238, "b": 157 }, { "v": "37", "r": 250, "g": 241, "b": 142 }, { "v": "46", "r": 252, "g": 248, "b": 129 }, { "v": "55", "r": 255, "g": 255, "b": 115 }, { "v": "64", "r": 255, "g": 242, "b": 99 }, { "v": "73", "r": 255, "g": 226, "b": 82 }, { "v": "82", "r": 255, "g": 211, "b": 66 }, { "v": "91", "r": 255, "g": 196, "b": 48 }, { "v": "100", "r": 255, "g": 184, "b": 31 }, { "v": "109", "r": 255, "g": 170, "b": 0 }, { "v": "118", "r": 252, "g": 153, "b": 5 }, { "v": "127", "r": 250, "g": 141, "b": 7 }, { "v": "136", "r": 247, "g": 129, "b": 10 }, { "v": "145", "r": 245, "g": 113, "b": 12 }, { "v": "154", "r": 242, "g": 102, "b": 15 }, { "v": "163", "r": 242, "g": 92, "b": 17 }, { "v": "172", "r": 230, "g": 86, "b": 14 }, { "v": "181", "r": 217, "g": 81, "b": 13 }, { "v": "190", "r": 204, "g": 75, "b": 10 }, { "v": "199", "r": 191, "g": 66, "b": 8 }, { "v": "208", "r": 181, "g": 61, "b": 5 }, { "v": "217", "r": 168, "g": 56, "b": 0 }];

  /***/
},
/* 146 */
/***/function (module, exports) {

  module.exports = [{ "v": "0", "r": 240, "g": 219, "b": 194 }, { "v": "29", "r": 235, "g": 203, "b": 197 }, { "v": "56", "r": 230, "g": 186, "b": 199 }, { "v": "84", "r": 224, "g": 171, "b": 202 }, { "v": "111", "r": 219, "g": 154, "b": 205 }, { "v": "140", "r": 212, "g": 138, "b": 205 }, { "v": "167", "r": 208, "g": 123, "b": 209 }, { "v": "195", "r": 201, "g": 106, "b": 212 }, { "v": "223", "r": 193, "g": 89, "b": 212 }, { "v": "250", "r": 186, "g": 75, "b": 214 }, { "v": "278", "r": 178, "g": 58, "b": 214 }, { "v": "306", "r": 172, "g": 37, "b": 217 }, { "v": "334", "r": 163, "g": 0, "b": 217 }, { "v": "361", "r": 155, "g": 0, "b": 207 }, { "v": "389", "r": 147, "g": 0, "b": 196 }, { "v": "417", "r": 140, "g": 0, "b": 186 }, { "v": "444", "r": 132, "g": 0, "b": 176 }, { "v": "472", "r": 124, "g": 0, "b": 166 }, { "v": "500", "r": 115, "g": 0, "b": 153 }, { "v": "527", "r": 109, "g": 0, "b": 145 }, { "v": "555", "r": 101, "g": 0, "b": 135 }, { "v": "583", "r": 94, "g": 0, "b": 125 }, { "v": "611", "r": 88, "g": 0, "b": 117 }, { "v": "638", "r": 82, "g": 0, "b": 110 }, { "v": "666", "r": 75, "g": 0, "b": 99 }];

  /***/
},
/* 147 */
/***/function (module, exports) {

  module.exports = [{ "v": "0", "r": 240, "g": 219, "b": 194 }, { "v": "2", "r": 242, "g": 224, "b": 182 }, { "v": "4", "r": 247, "g": 232, "b": 168 }, { "v": "5", "r": 250, "g": 238, "b": 157 }, { "v": "7", "r": 250, "g": 241, "b": 142 }, { "v": "8", "r": 252, "g": 248, "b": 129 }, { "v": "10", "r": 255, "g": 255, "b": 115 }, { "v": "11", "r": 255, "g": 242, "b": 99 }, { "v": "13", "r": 255, "g": 226, "b": 82 }, { "v": "14", "r": 255, "g": 211, "b": 66 }, { "v": "16", "r": 255, "g": 196, "b": 48 }, { "v": "17", "r": 255, "g": 184, "b": 31 }, { "v": "19", "r": 255, "g": 170, "b": 0 }, { "v": "20", "r": 252, "g": 153, "b": 5 }, { "v": "21", "r": 250, "g": 141, "b": 7 }, { "v": "23", "r": 247, "g": 129, "b": 10 }, { "v": "24", "r": 245, "g": 113, "b": 12 }, { "v": "26", "r": 242, "g": 102, "b": 15 }, { "v": "27", "r": 242, "g": 92, "b": 17 }, { "v": "29", "r": 230, "g": 86, "b": 14 }, { "v": "30", "r": 217, "g": 81, "b": 13 }, { "v": "32", "r": 204, "g": 75, "b": 10 }, { "v": "33", "r": 191, "g": 66, "b": 8 }, { "v": "35", "r": 181, "g": 61, "b": 5 }, { "v": "36", "r": 168, "g": 56, "b": 0 }];

  /***/
},
/* 148 */
/***/function (module, exports) {

  module.exports = [{ "v": "0", "r": 240, "g": 219, "b": 194 }, { "v": "2", "r": 235, "g": 203, "b": 197 }, { "v": "3", "r": 230, "g": 186, "b": 199 }, { "v": "5", "r": 224, "g": 171, "b": 202 }, { "v": "6", "r": 219, "g": 154, "b": 205 }, { "v": "7", "r": 212, "g": 138, "b": 205 }, { "v": "8", "r": 208, "g": 123, "b": 209 }, { "v": "9", "r": 201, "g": 106, "b": 212 }, { "v": "11", "r": 193, "g": 89, "b": 212 }, { "v": "12", "r": 186, "g": 75, "b": 214 }, { "v": "13", "r": 178, "g": 58, "b": 214 }, { "v": "14", "r": 172, "g": 37, "b": 217 }, { "v": "16", "r": 163, "g": 0, "b": 217 }, { "v": "17", "r": 155, "g": 0, "b": 207 }, { "v": "18", "r": 147, "g": 0, "b": 196 }, { "v": "19", "r": 140, "g": 0, "b": 186 }, { "v": "20", "r": 132, "g": 0, "b": 176 }, { "v": "22", "r": 124, "g": 0, "b": 166 }, { "v": "23", "r": 115, "g": 0, "b": 153 }, { "v": "24", "r": 109, "g": 0, "b": 145 }, { "v": "25", "r": 101, "g": 0, "b": 135 }, { "v": "26", "r": 94, "g": 0, "b": 125 }, { "v": "28", "r": 88, "g": 0, "b": 117 }, { "v": "29", "r": 82, "g": 0, "b": 110 }, { "v": "30", "r": 75, "g": 0, "b": 99 }];

  /***/
}]);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

(function (previousMethods) {
    if (typeof previousMethods === 'undefined') {
        // Defining previously that object allows you to use that plugin even if you have overridden L.map
        previousMethods = {
            getCenter: L.Map.prototype.getCenter,
            setView: L.Map.prototype.setView,
            setZoomAround: L.Map.prototype.setZoomAround,
            getBoundsZoom: L.Map.prototype.getBoundsZoom,
            PopupAdjustPan: L.Popup.prototype._adjustPan,
            RendererUpdate: L.Renderer.prototype._update
        };
    }

    L.Map.include({
        getBounds: function getBounds() {
            if (this._viewport) {
                return this.getViewportLatLngBounds();
            } else {
                var bounds = this.getPixelBounds(),
                    sw = this.unproject(bounds.getBottomLeft()),
                    ne = this.unproject(bounds.getTopRight());

                return new L.LatLngBounds(sw, ne);
            }
        },

        getViewport: function getViewport() {
            return this._viewport;
        },

        getViewportBounds: function getViewportBounds() {
            var vp = this._viewport,
                topleft = L.point(vp.offsetLeft, vp.offsetTop),
                vpsize = L.point(vp.clientWidth, vp.clientHeight);

            if (vpsize.x === 0 || vpsize.y === 0) {
                //Our own viewport has no good size - so we fallback to the container size:
                vp = this.getContainer();
                if (vp) {
                    topleft = L.point(0, 0);
                    vpsize = L.point(vp.clientWidth, vp.clientHeight);
                }
            }

            return L.bounds(topleft, topleft.add(vpsize));
        },

        getViewportLatLngBounds: function getViewportLatLngBounds() {
            var bounds = this.getViewportBounds();
            return L.latLngBounds(this.containerPointToLatLng(bounds.min), this.containerPointToLatLng(bounds.max));
        },

        getOffset: function getOffset() {
            var mCenter = this.getSize().divideBy(2),
                vCenter = this.getViewportBounds().getCenter();

            return mCenter.subtract(vCenter);
        },

        getCenter: function getCenter(withoutViewport) {
            var center = previousMethods.getCenter.call(this);

            if (this.getViewport() && !withoutViewport) {
                var zoom = this.getZoom(),
                    point = this.project(center, zoom);
                point = point.subtract(this.getOffset());

                center = this.unproject(point, zoom);
            }

            return center;
        },

        setView: function setView(center, zoom, options) {
            center = L.latLng(center);
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);

            if (this.getViewport()) {
                var point = this.project(center, this._limitZoom(zoom));
                point = point.add(this.getOffset());
                center = this.unproject(point, this._limitZoom(zoom));
            }

            return previousMethods.setView.call(this, center, zoom, options);
        },

        setZoomAround: function setZoomAround(latlng, zoom, options) {
            var vp = this.getViewport();

            if (vp) {
                var scale = this.getZoomScale(zoom),
                    viewHalf = this.getViewportBounds().getCenter(),
                    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
                    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
                    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

                return this.setView(newCenter, zoom, { zoom: options });
            } else {
                return previousMethods.setZoomAround.call(this, latlng, zoom, options);
            }
        },

        getBoundsZoom: function getBoundsZoom(bounds, inside, padding) {
            // (LatLngBounds[, Boolean, Point]) -> Number
            bounds = L.latLngBounds(bounds);
            padding = L.point(padding || [0, 0]);

            var zoom = this.getZoom() || 0,
                min = this.getMinZoom(),
                max = this.getMaxZoom(),
                nw = bounds.getNorthWest(),
                se = bounds.getSouthEast(),
                vp = this.getViewport(),
                size = (vp ? L.point(vp.clientWidth, vp.clientHeight) : this.getSize()).subtract(padding),
                boundsSize = this.project(se, zoom).subtract(this.project(nw, zoom)),
                snap = L.Browser.any3d ? this.options.zoomSnap : 1;

            var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);

            zoom = this.getScaleZoom(scale, zoom);

            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }

            return Math.max(min, Math.min(max, zoom));
        }
    });

    L.Map.include({
        setActiveArea: function setActiveArea(css, keepCenter, animate) {
            var center;
            if (keepCenter && this._zoom) {
                // save center if map is already initialized
                // and keepCenter is passed
                center = this.getCenter();
            }

            if (!this._viewport) {
                //Make viewport if not already made
                var container = this.getContainer();
                this._viewport = L.DomUtil.create('div', '');
                container.insertBefore(this._viewport, container.firstChild);
            }

            if (typeof css === 'string') {
                this._viewport.className = css;
            } else {
                L.extend(this._viewport.style, css);
            }

            if (center) {
                this.setView(center, this.getZoom(), { animate: !!animate });
            }
            return this;
        }
    });

    L.Renderer.include({
        _onZoom: function _onZoom() {
            this._updateTransform(this._map.getCenter(true), this._map.getZoom());
        },

        _update: function _update() {
            previousMethods.RendererUpdate.call(this);
            this._center = this._map.getCenter(true);
        }
    });

    L.GridLayer.include({
        _updateLevels: function _updateLevels() {

            var zoom = this._tileZoom,
                maxZoom = this.options.maxZoom;

            if (zoom === undefined) {
                return undefined;
            }

            for (var z in this._levels) {
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                } else {
                    L.DomUtil.remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    delete this._levels[z];
                }
            }

            var level = this._levels[zoom],
                map = this._map;

            if (!level) {
                level = this._levels[zoom] = {};

                level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;

                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;

                this._setZoomTransform(level, map.getCenter(true), map.getZoom());

                // force the browser to consider the newly added element for transition
                L.Util.falseFn(level.el.offsetWidth);
            }

            this._level = level;

            return level;
        },

        _resetView: function _resetView(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(true), this._map.getZoom(), animating, animating);
        },

        _update: function _update(center) {
            var map = this._map;
            if (!map) {
                return;
            }
            var zoom = map.getZoom();

            if (center === undefined) {
                center = map.getCenter(this);
            }
            if (this._tileZoom === undefined) {
                return;
            } // if out of minzoom/maxzoom

            var pixelBounds = this._getTiledPixelBounds(center),
                tileRange = this._pxBoundsToTileRange(pixelBounds),
                tileCenter = tileRange.getCenter(),
                queue = [];

            for (var key in this._tiles) {
                this._tiles[key].current = false;
            }

            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);return;
            }

            // create a queue of coordinates to load tiles from
            for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
                for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
                    var coords = new L.Point(i, j);
                    coords.z = this._tileZoom;

                    if (!this._isValidTile(coords)) {
                        continue;
                    }

                    var tile = this._tiles[this._tileCoordsToKey(coords)];
                    if (tile) {
                        tile.current = true;
                    } else {
                        queue.push(coords);
                    }
                }
            }

            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function (a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });

            if (queue.length !== 0) {
                // if its the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles
                    this.fire('loading');
                }

                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();

                for (i = 0; i < queue.length; i++) {
                    this._addTile(queue[i], fragment);
                }

                this._level.el.appendChild(fragment);
            }
        }
    });

    L.Popup.include({
        _adjustPan: function _adjustPan() {
            if (!this._map._viewport) {
                previousMethods.PopupAdjustPan.call(this);
            } else {
                if (!this.options.autoPan || this._map._panAnim && this._map._panAnim._inProgress) {
                    return;
                }

                var map = this._map,
                    vp = map._viewport,
                    containerHeight = this._container.offsetHeight,
                    containerWidth = this._containerWidth,
                    vpTopleft = L.point(vp.offsetLeft, vp.offsetTop),
                    layerPos = new L.Point(this._containerLeft - vpTopleft.x, -containerHeight - this._containerBottom - vpTopleft.y);

                if (this._zoomAnimated) {
                    layerPos._add(L.DomUtil.getPosition(this._container));
                }

                var containerPos = map.layerPointToContainerPoint(layerPos),
                    padding = L.point(this.options.autoPanPadding),
                    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
                    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
                    size = L.point(vp.clientWidth, vp.clientHeight),
                    dx = 0,
                    dy = 0;

                if (containerPos.x + containerWidth + paddingBR.x > size.x) {
                    // right
                    dx = containerPos.x + containerWidth - size.x + paddingBR.x;
                }
                if (containerPos.x - dx - paddingTL.x < 0) {
                    // left
                    dx = containerPos.x - paddingTL.x;
                }
                if (containerPos.y + containerHeight + paddingBR.y > size.y) {
                    // bottom
                    dy = containerPos.y + containerHeight - size.y + paddingBR.y;
                }
                if (containerPos.y - dy - paddingTL.y < 0) {
                    // top
                    dy = containerPos.y - paddingTL.y;
                }

                // @namespace Map
                // @section Popup events
                // @event autopanstart
                // Fired when the map starts autopanning when opening a popup.
                if (dx || dy) {
                    map.fire('autopanstart').panBy([dx, dy]);
                }
            }
        }
    });
})(window.leafletActiveAreaPreviousMethods);
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }
}();

;

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openLightbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeLightbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(61);


/**
 * Action creator that signals lightbox to be opened
 * @param {string} referrer - What is opening the lightbox this will determine what layout the lightbox uses
 * @param {object} payload - The data passed from the referrer
 */
var openLightbox = function openLightbox(referrer, payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* LIGHTBOX_OPEN */],
    referrer: referrer,
    payload: payload
  };
};

var closeLightbox = function closeLightbox() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["b" /* LIGHTBOX_CLOSE */]
  };
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(openLightbox, 'openLightbox', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/lightboxActions.js');

  __REACT_HOT_LOADER__.register(closeLightbox, 'closeLightbox', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/lightboxActions.js');
}();

;

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleBasemap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectMapLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deselectMapLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deselectAllMapLayers; });
/* unused harmony export zoomToMapHome */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return zoomToLayerExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchGeoJsonLayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config__ = __webpack_require__(172);






// toggling the basemap tile layer
var toggleBasemap = function toggleBasemap(basemap) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["f" /* TOGGLE_BASEMAP */],
    basemap: basemap
  };
};

// selecting or deselecting map layers
var selectMapLayer = function selectMapLayer(layer) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["g" /* SELECT_MAP_LAYER */],
    layer: layer
  };
};

var deselectMapLayer = function deselectMapLayer(layer) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["h" /* DESELECT_MAP_LAYER */],
    layer: layer
  };
};

var deselectAllMapLayers = function deselectAllMapLayers() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["i" /* DESELECT_ALL_MAP_LAYERS */]
  };
};

// updating map zoom level & center programatically
var zoomToMapHome = function zoomToMapHome() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["j" /* ZOOM_TO_MAP_HOME */]
  };
};

var zoomToLayerExtent = function zoomToLayerExtent(layer) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["k" /* ZOOM_TO_MAP_LAYER_EXTENT */],
    layer: layer
  };
};

// next 4 action creators are for GeoJSON async data requests
var geojsonLayerRequest = function geojsonLayerRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["l" /* GEOJSON_LAYER_REQUEST */]
  };
};

var geojsonLayerSuccess = function geojsonLayerSuccess(layer, json) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["m" /* GEOJSON_LAYER_SUCCESS */],
    layer: layer,
    json: json
  };
};

var geojsonLayerError = function geojsonLayerError(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["n" /* GEOJSON_LAYER_ERROR */],
    error: error
  };
};

// combines the above 3 action creators, only this one is exported
var fetchGeoJsonLayer = function fetchGeoJsonLayer(datacode) {
  var url = __WEBPACK_IMPORTED_MODULE_2__common_config__["a" /* s3Url */] + '/sources/' + datacode + '.geojson';

  return function (dispatch) {
    // first we tell the app we are making an async request so that the app can respond with a
    // loading GIF, disable certain UI interactions, etc. if desired
    dispatch(geojsonLayerRequest());
    // axios is a promise based library for handling XHR
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(url).then(function (result) {
      if (!result || !result.data) {
        throw new Error('problem loading data');
      }
      // on a successful response dispatch the appropriate action creator with the data & datacode
      dispatch(geojsonLayerSuccess(datacode, result.data));
    }).catch(function (error) {
      return dispatch(geojsonLayerError(error));
    });
  };
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(toggleBasemap, 'toggleBasemap', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(selectMapLayer, 'selectMapLayer', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(deselectMapLayer, 'deselectMapLayer', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(deselectAllMapLayers, 'deselectAllMapLayers', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(zoomToMapHome, 'zoomToMapHome', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(zoomToLayerExtent, 'zoomToLayerExtent', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(geojsonLayerRequest, 'geojsonLayerRequest', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(geojsonLayerSuccess, 'geojsonLayerSuccess', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(geojsonLayerError, 'geojsonLayerError', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');

  __REACT_HOT_LOADER__.register(fetchGeoJsonLayer, 'fetchGeoJsonLayer', '/Users/gin/ginfo/canopyplanet_expert_map/src/actions/mapLayersActions.js');
}();

;

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sanitize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sanitize_html__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sanitize_html__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_marked___default.a; });



// options for sanitizing HTML
var sanitize = function sanitize(input) {
  return __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default()(input, {
    allowedTags: __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default.a.defaults.allowedTags.concat(['sup', 'img']),
    allowedAttributes: {
      img: ['src', 'alt'],
      a: ['href', 'target', 'rel']
    }
  });
};

// customize the renderer for marked so we can make hyperlinks open new browser tabs/windows
var renderer = new __WEBPACK_IMPORTED_MODULE_0_marked___default.a.Renderer();

// eslint-disable-next-line
renderer.link = function (href, title, text) {
  if (this.options.sanitize) {
    var prot = void 0;
    try {
      prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
    } catch (e) {
      return '';
    }
    if (
    // eslint-disable-next-line
    prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
      return '';
    }
  }

  // eslint-disable-next-line
  var out = '<a target="_blank" rel="noopener noreferrer" href="' + href + '"';

  if (title) {
    // eslint-disable-next-line
    out += ' title="' + title + '"';
  }

  // eslint-disable-next-line
  out += '>' + text + '</a>';

  return out;
};

// settings for markdown parser
__WEBPACK_IMPORTED_MODULE_0_marked___default.a.setOptions({
  renderer: renderer,
  gfm: false,
  sanitize: false,
  pedantic: false,
  smartLists: false,
  smartypants: true
});


;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sanitize, 'sanitize', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/utils.js');

  __REACT_HOT_LOADER__.register(renderer, 'renderer', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/utils.js');
}();

;

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_auto_init_dist_mdc_autoInit__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_auto_init_dist_mdc_autoInit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_auto_init_dist_mdc_autoInit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_LeafletMapConnected__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_SidebarConnected__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Lightbox_Lightbox__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_MapLegendConnected__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BasemapSelector__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import the dist file because the index.js file gives webpack-uglify plugin problems


// import components






var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // set up JS for Material Design
      __WEBPACK_IMPORTED_MODULE_2__material_auto_init_dist_mdc_autoInit___default()();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        return true;
      }

      if (nextProps.appHeight !== this.props.appHeight) {
        return true;
      }

      if (nextProps.basemap !== this.props.basemap) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          closeLightbox = _props.closeLightbox,
          referrer = _props.referrer,
          payload = _props.payload,
          basemap = _props.basemap,
          toggleBasemap = _props.toggleBasemap;

      // pass appHeight to Sidebar so that if a browser resize occurs, the LayersList height will be
      // computed again. LayersList height is dependent on whether or not Instructions is opened / closed

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'App' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_LeafletMapConnected__["a" /* default */], { lat: 0, lng: 0, zoom: 2 }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_SidebarConnected__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Lightbox_Lightbox__["a" /* default */], _extends({ isOpen: isOpen, closeLightbox: closeLightbox, referrer: referrer, payload: payload }, { content: '' })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__BasemapSelector__["a" /* default */], { selected: basemap, handleClick: toggleBasemap }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_MapLegendConnected__["a" /* default */], null)
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

App.propTypes = {
  appHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  appWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  basemap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  closeLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  referrer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),
  toggleBasemap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
App.defaultProps = {
  referrer: '',
  payload: {}
};
var _default = App;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(App, 'App', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/App.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/App.jsx');
}();

;

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var BasemapSelector = function BasemapSelector(props) {
  var selected = props.selected,
      handleClick = props.handleClick;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'BasemapSelector' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        onClick: function onClick() {
          return handleClick('detailmap');
        },
        className: selected === 'detailmap' ? 'active' : ''
      },
      'Placemarked'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        onClick: function onClick() {
          return handleClick('watercolor');
        },
        className: selected === 'watercolor' ? 'active' : ''
      },
      'Watercolor'
    )
  );
};

BasemapSelector.propTypes = {
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = BasemapSelector;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BasemapSelector, 'BasemapSelector', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/BasemapSelector.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/BasemapSelector.jsx');
}();

;

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// argh, this has to be a class component, not a functional component, because it needs a ref!

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // pass a reference to this component to its parent
      this.props.getRef(this.footer, 'footer');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var openLightbox = this.props.openLightbox;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'Footer',
          ref: function ref(_) {
            _this2.footer = _;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn-link-style', onClick: function onClick() {
              return openLightbox();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'label' },
            'About'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-info' })
        )
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Footer.propTypes = {
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var _default = Footer;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, 'Footer', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Footer.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Footer.jsx');
}();

;

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_collapse__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_collapse__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Instructions = function (_Component) {
  _inherits(Instructions, _Component);

  function Instructions() {
    _classCallCheck(this, Instructions);

    var _this = _possibleConstructorReturn(this, (Instructions.__proto__ || Object.getPrototypeOf(Instructions)).call(this));

    _this.instructions = null;
    return _this;
  }

  _createClass(Instructions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          collapseOnRest = _props.collapseOnRest,
          handleClick = _props.handleClick,
          isOpened = _props.isOpened;

      var btmClassName = isOpened ? 'bottom opened' : 'bottom';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: function ref(_) {
            _this2.instructions = _;
          },
          className: 'Instructions'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_collapse__["Collapse"],
          { isOpened: isOpened, onRest: function onRest() {
              return collapseOnRest(_this2.instructions);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Select a topic'
            ),
            ' to explore data layers and learn about the world\'s most threatened forest ecosystems.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: btmClassName },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'close', onClick: handleClick },
            isOpened ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-up', 'aria-hidden': 'true' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-down', 'aria-hidden': 'true' })
          )
        )
      );
    }
  }]);

  return Instructions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Instructions.propTypes = {
  collapseOnRest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired, // callback for when the collapse container finishes animating
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired, // callback that sets state for isOpened in Sidebar
  isOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired };
var _default = Instructions;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Instructions, 'Instructions', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Instructions.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Instructions.jsx');
}();

;

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




/**
 * Functional Component that represents a data layer selector list item in the side bar
*/
var LayerSelector = function LayerSelector(props) {
  var checked = props.checked,
      description = props.description,
      shortdescription = props.shortdescription,
      source = props.source,
      sourceurl = props.sourceurl,
      fullcitation = props.fullcitation,
      id = props.id,
      name = props.name,
      _onChange = props.onChange,
      openLightbox = props.openLightbox,
      onZoomBtnClick = props.onZoomBtnClick;

  // data that gets passed to the lightbox

  var payload = {
    name: name,
    description: description,
    shortdescription: shortdescription,
    source: source,
    sourceurl: sourceurl,
    fullcitation: fullcitation
  };

  var btnZoomClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    'btn-icon-style': true,
    'btn-zoom-to': true,
    disabled: !checked
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'LayerSelector' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'mdc-form-field' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'checkbox-label mdc-checkbox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          id: id,
          type: 'checkbox',
          className: 'mdc-checkbox__native-control',
          tabIndex: '0',
          checked: checked,
          onChange: function onChange() {
            return _onChange(id);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'mdc-checkbox__background' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'svg',
            { className: 'mdc-checkbox__checkmark', viewBox: '0 0 24 24' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
              className: 'mdc-checkbox__checkmark__path',
              fill: 'none',
              stroke: 'white',
              d: 'M1.73,12.91 8.1,19.28 22.79,4.59'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mdc-checkbox__mixedmark' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: 'mdc-checkbox-label', htmlFor: id },
        name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'layer-selector-btns' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: btnZoomClasses, disabled: !checked, onClick: function onClick() {
              return onZoomBtnClick(id);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'btn-icon-style btn-read-more',
            onClick: function onClick() {
              return openLightbox('dataLayer', payload);
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'description-read-more' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'description' },
        shortdescription || '*needs a short description*'
      )
    )
  );
};

LayerSelector.propTypes = {
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onZoomBtnClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  shortdescription: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sourceurl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fullcitation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

LayerSelector.defaultProps = {
  description: 'needs a long description',
  shortdescription: 'some descriptive text here',
  source: 'info about the source',
  sourceurl: '',
  fullcitation: 'fullcitation text'
};

var _default = LayerSelector;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LayerSelector, 'LayerSelector', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayerSelector.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayerSelector.jsx');
}();

;

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LayerSelector__ = __webpack_require__(298);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Class that houses the list of data layers in the Sidebar
 * Extends React.Component
*/

var LayersList = function (_Component) {
  _inherits(LayersList, _Component);

  function LayersList() {
    _classCallCheck(this, LayersList);

    var _this = _possibleConstructorReturn(this, (LayersList.__proto__ || Object.getPrototypeOf(LayersList)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(LayersList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.selectedTab !== this.props.selectedTab) {
        return true;
      }

      if (nextProps.activeLayers.length !== this.props.activeLayers.length) {
        return true;
      }

      if (nextProps.height !== this.props.height) {
        return true;
      }

      return false;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      var _props = this.props,
          dataLayers = _props.dataLayers,
          openLightbox = _props.openLightbox,
          selectMapLayer = _props.selectMapLayer,
          deselectMapLayer = _props.deselectMapLayer;


      if (dataLayers[value].selected) {
        deselectMapLayer(value);
      } else {
        // hack: force open the lightbox for this one layer
        if (value.indexOf('deforestation_fronts') !== -1) {
          var name = dataLayers[value].layerlabel;
          var description = dataLayers[value].description;
          var shortdescription = dataLayers[value].shortdescription;
          var source = dataLayers[value].source;
          var sourceurl = dataLayers[value].sourceurl;
          var fullcitation = dataLayers[value].fullcitation;
          var payload = {
            name: name,
            description: description,
            shortdescription: shortdescription,
            source: source,
            sourceurl: sourceurl,
            fullcitation: fullcitation
          };
          openLightbox('dataLayer', payload);
        }

        // and the usual selectMapLayer
        selectMapLayer(value);
      }
    }
  }, {
    key: 'renderLayersList',
    value: function renderLayersList() {
      var _this2 = this;

      var _props2 = this.props,
          dataLayers = _props2.dataLayers,
          openLightbox = _props2.openLightbox,
          selectedTab = _props2.selectedTab,
          zoomToLayerExtent = _props2.zoomToLayerExtent;


      return Object.values(dataLayers).filter(function (layer) {
        return layer.theme === selectedTab;
      }).sort(function (a, b) {
        if (a.listed_order < b.listed_order) {
          return -1;
        }
        if (a.listed_order > b.listed_order) {
          return 1;
        }
        return 0;
      }).map(function (layer) {
        var datacode = layer.datacode,
            layerlabel = layer.layerlabel,
            selected = layer.selected,
            shortdescription = layer.shortdescription,
            description = layer.description,
            source = layer.source,
            sourceurl = layer.sourceurl,
            fullcitation = layer.fullcitation;


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LayerSelector__["a" /* default */], {
          key: datacode,
          id: datacode,
          name: layerlabel,
          checked: selected,
          shortdescription: shortdescription,
          description: description,
          source: source,
          sourceurl: sourceurl,
          fullcitation: fullcitation,
          onChange: _this2.handleChange,
          openLightbox: openLightbox,
          onZoomBtnClick: zoomToLayerExtent
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // component height depends on whether or not Instructions UI is opened or closed
      var layersListStyle = {
        height: this.props.height || 'auto'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'LayersList', style: layersListStyle },
        this.renderLayersList()
      );
    }
  }]);

  return LayersList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LayersList.propTypes = {
  activeLayers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  // eslint-disable-next-line
  dataLayers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  deselectMapLayer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectMapLayer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  zoomToLayerExtent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
LayersList.defaultProps = {
  height: 'auto'
};
var _default = LayersList;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LayersList, 'LayersList', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayersList.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayersList.jsx');
}();

;

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LayersTabs = function (_Component) {
  _inherits(LayersTabs, _Component);

  function LayersTabs() {
    _classCallCheck(this, LayersTabs);

    return _possibleConstructorReturn(this, (LayersTabs.__proto__ || Object.getPrototypeOf(LayersTabs)).apply(this, arguments));
  }

  _createClass(LayersTabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // pass a reference to this component to its parent
      this.props.getRef(this.layersTab, 'layersTab');
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.selectedTab !== this.props.selectedTab) {
        return true;
      }

      return false;
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      var _props = this.props,
          selectedTab = _props.selectedTab,
          selectLayersTab = _props.selectLayersTab;

      // note: a prop called "themes" declares this same info, but we need it in this arbitray order

      return ['forests', 'species', 'carbon', 'landscapes'].map(function (theme) {
        var btnClassName = selectedTab === theme ? 'layers-tab active' : 'layers-tab';
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: theme },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: btnClassName, onClick: function onClick() {
                return selectLayersTab(theme);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'theme-icon-img ' + theme }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              theme
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'LayersTabs',
          ref: function ref(_) {
            _this2.layersTab = _;
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          null,
          this.renderTabs()
        )
      );
    }
  }]);

  return LayersTabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LayersTabs.propTypes = {
  themes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  selectLayersTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  selectedTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  getRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var _default = LayersTabs;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LayersTabs, 'LayersTabs', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayersTabs.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LayersTabs.jsx');
}();

;

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_leaflet_active_area__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_leaflet_active_area___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lib_leaflet_active_area__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResetLayers__ = __webpack_require__(306);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import { baseURL } from '../common/config';


// set default image paths for Leaflet
// note the "gin-static-site-starter" as the first directory if NODE_ENV === production
// this is because Github Pages will be looking for the markers at:
// https://greeninfo-network.github.io/gin-static-site-starter/assets/icons/<filename>.png
// while locally it will be localhost:8080/assets/icons/<filename>.png
__WEBPACK_IMPORTED_MODULE_2_leaflet__["Icon"].Default.imagePath = '../../';
__WEBPACK_IMPORTED_MODULE_2_leaflet__["Icon"].Default.mergeOptions({
  iconRetinaUrl: 'assets/icons/marker-icon-2x.png',
  iconUrl: 'assets/icons/marker-icon.png',
  shadowUrl: 'assets/icons/marker-shadow.png'
});

var LeafletMap = function (_Component) {
  _inherits(LeafletMap, _Component);

  function LeafletMap(props) {
    _classCallCheck(this, LeafletMap);

    var _this = _possibleConstructorReturn(this, (LeafletMap.__proto__ || Object.getPrototypeOf(LeafletMap)).call(this, props));

    var zoom = props.zoom;


    var basemapsConfig = [{
      attrib: 'CARTO, OSM',
      label: 'Detail Map',
      tooltip: 'Detail Map',
      type: 'xyz',
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}@2x.png'
    }, {
      attrib: 'Stamen, OSM',
      label: 'Watercolor',
      tooltip: 'Watercolor',
      type: 'xyz',
      url: 'https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg'
    }];

    // custom marker base class for warning icon
    var WarningIcon = __WEBPACK_IMPORTED_MODULE_2_leaflet__["Icon"].extend({
      options: {
        iconUrl: './assets/icons/warning_icon.png',
        iconRetinaUrl: './assets/icons/warning_icon@2x.png',
        shadowUrl: './assets/icons/warning_icon_shadow.png',
        iconSize: [39, 37],
        shadowSize: [39, 37],
        iconAnchor: [19, 18],
        shadowAnchor: [19, 18]
      }
    });

    _this.warning_icon = new WarningIcon();

    _this.mapOptions = {
      minZoom: zoom,
      maxZoom: 7,
      inertia: false,
      attributionControl: false,
      zoomControl: false
    };

    // to store geoJson layers
    _this.vectorLayers = null;
    // clear selected layers in map reducer
    _this.clearSelectedLayers = _this.clearSelectedLayers.bind(_this);

    // basemap tile layers that can be toggled
    _this.watercolor = __WEBPACK_IMPORTED_MODULE_2_leaflet__["tileLayer"](basemapsConfig[1].url, {
      attribution: basemapsConfig[1].attrib,
      zIndex: 0
    });
    _this.detailmap = __WEBPACK_IMPORTED_MODULE_2_leaflet__["tileLayer"](basemapsConfig[0].url, {
      attribution: basemapsConfig[0].attrib,
      zIndex: 0
    });
    return _this;
  }

  _createClass(LeafletMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initMap();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var activeLayers = nextProps.activeLayers,
          basemap = nextProps.basemap,
          dataLayers = nextProps.dataLayers,
          isFetchingGeoJson = nextProps.isFetchingGeoJson,
          zoomLayer = nextProps.zoomLayer;

      // if there are more or less items in the activeLayers array, toggle map layers

      if (activeLayers.length !== this.props.activeLayers.length) {
        this.handleLayerToggle(dataLayers);
      }

      // also call handleLayerToggle if data for a GeoJSON layer was successfully fetched
      if (!isFetchingGeoJson && this.props.isFetchingGeoJson) {
        this.handleLayerToggle(dataLayers);
      }

      // if the datacode for the zoomLayer updates, update the map view
      if (zoomLayer !== '') {
        this.zoomToMapLayer(zoomLayer);
      }

      // if the basemap is toggled
      if (basemap !== this.props.basemap) {
        this.toggleBasemapLayer(basemap);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      // Let Leaflet handle this part of the DOM, not React!
      return false;
    }
  }, {
    key: 'clearSelectedLayers',
    value: function clearSelectedLayers() {
      this.props.deselectAllMapLayers();
    }
  }, {
    key: 'zoomToMapLayer',
    value: function zoomToMapLayer(layerCode) {
      var _props = this.props,
          dataLayers = _props.dataLayers,
          zoom = _props.zoom,
          lat = _props.lat,
          lng = _props.lng,
          zoomToLayerExtent = _props.zoomToLayerExtent;

      var vectorLayers = this.vectorLayers;
      var layer = dataLayers[layerCode];

      // if the layer has not yet been added or is not active, do nothing
      if (!layer.selected) return;
      if (layer.datatype === 'geojson' && !vectorLayers.hasLayer(layer.leaflet._leaflet_id)) {
        return;
      }

      var datatype = layer.datatype;

      if (datatype === 'geojson') {
        this.map.fitBounds(layer.leaflet.getBounds());
      }

      if (datatype === 'tileLayer') {
        // TO DO: use a bounding box property of the dataLayer?
        this.map.setView([lat, lng], zoom);
      }

      // fire the zoomToLayerExtent action again, so that it may be called for the same layer
      // over and over, e.g. after it was called the user pans / zooms, then calls it again
      zoomToLayerExtent('');
    }
  }, {
    key: 'toggleGeoJsonLayer',
    value: function toggleGeoJsonLayer(layer) {
      // add or remove a geojson layer from vectorLayers feature group
      var vectorLayers = this.vectorLayers;

      // if the layer is not selected, has an L.geoJson class, and is present in the map layer group,
      // remove it
      if (!layer.selected && layer.leaflet && vectorLayers.hasLayer(layer.leaflet._leaflet_id)) {
        vectorLayers.removeLayer(layer.leaflet);
      }

      // if we don't have the GeoJSON layer yet, make an HTTP Request for it
      if (layer.selected && !layer.leaflet) {
        this.props.fetchGeoJsonLayer(layer.datacode);
      }

      // if we've already fetched geojson data and created the leaflet layer
      // then add it to the layers group
      if (layer.selected && layer.leaflet) {
        vectorLayers.addLayer(layer.leaflet.setStyle(layer.style));
      }
    }
  }, {
    key: 'toggleTileLayer',
    value: function toggleTileLayer(layer) {
      // add or remove a tileLayer from the map
      if (!layer.selected && this.map.hasLayer(layer.leaflet)) {
        this.map.removeLayer(layer.leaflet);
      }

      if (layer.selected && !this.map.hasLayer(layer.leaflet)) {
        if (layer.tile_opacity !== null) {
          layer.leaflet.setOpacity(layer.tile_opacity);
        }
        this.map.addLayer(layer.leaflet);
      }
    }
  }, {
    key: 'toggleMarkerLayer',
    value: function toggleMarkerLayer(layer) {
      var openLightbox = this.props.openLightbox;


      var name = layer.layerlabel;
      var description = layer.description;
      var shortdescription = layer.shortdescription;
      var source = layer.source;
      var sourceurl = layer.sourceurl;
      var fullcitation = layer.fullcitation;

      // data that gets passed to the lightbox
      var payload = {
        name: name,
        description: description,
        shortdescription: shortdescription,
        source: source,
        sourceurl: sourceurl,
        fullcitation: fullcitation
      };

      // add or remove a tileLayer from the map
      if (!layer.selected && this.map.hasLayer(layer.leaflet)) {
        this.map.removeLayer(layer.leaflet);
      }

      if (layer.selected && !this.map.hasLayer(layer.leaflet)) {
        // hack
        layer.leaflet.setIcon(this.warning_icon);
        layer.leaflet.on('click', function () {
          return openLightbox('dataLayer', payload);
        });
        this.map.addLayer(layer.leaflet);
      }
    }
  }, {
    key: 'toggleBasemapLayer',
    value: function toggleBasemapLayer(basemap) {
      if (basemap === 'watercolor' && !this.map.hasLayer(this.watercolor)) {
        this.map.removeLayer(this.detailmap);
        this.map.addLayer(this.watercolor);
      }
      if (basemap === 'detailmap' && !this.map.hasLayer(this.detailmap)) {
        this.map.removeLayer(this.watercolor);
        this.map.addLayer(this.detailmap);
      }
    }
  }, {
    key: 'handleLayerToggle',
    value: function handleLayerToggle(dataLayers) {
      var _this2 = this;

      Object.keys(dataLayers).forEach(function (layer) {
        var o = dataLayers[layer];

        if (o.datatype === 'geojson') {
          _this2.toggleGeoJsonLayer(o);
        }

        if (o.datatype === 'tileLayer') {
          _this2.toggleTileLayer(o);
        }

        if (o.datatype === 'marker') {
          _this2.toggleMarkerLayer(o);
        }
      });
    }
  }, {
    key: 'initMap',
    value: function initMap() {
      // map setup
      var _props2 = this.props,
          dataLayers = _props2.dataLayers,
          lat = _props2.lat,
          lng = _props2.lng,
          zoom = _props2.zoom;


      this.map = new __WEBPACK_IMPORTED_MODULE_2_leaflet__["Map"]('map', this.mapOptions).setActiveArea('active-area').setView([lat, lng], zoom);

      this.map.scrollWheelZoom.disable();

      this.watercolor.addTo(this.map);

      this.vectorLayers = __WEBPACK_IMPORTED_MODULE_2_leaflet__["featureGroup"]().addTo(this.map);

      __WEBPACK_IMPORTED_MODULE_2_leaflet__["control"].zoom({ position: 'topright' }).addTo(this.map);

      __WEBPACK_IMPORTED_MODULE_2_leaflet__["control"].scale({ position: 'bottomright' }).addTo(this.map);

      // make sure any default data layers are enabled
      this.handleLayerToggle(dataLayers);

      window.map = this.map;
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: Because shouldComponentUpdate always returns false, Render is only called once when the app loads
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'map' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ResetLayers__["a" /* default */], { handleClick: this.clearSelectedLayers }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'active-area' })
      );
    }
  }]);

  return LeafletMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LeafletMap.propTypes = {
  appWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  activeLayers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  basemap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  deselectAllMapLayers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  fetchGeoJsonLayer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isFetchingGeoJson: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  // eslint-disable-next-line
  dataLayers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  lat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  lng: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  zoom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  zoomLayer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  zoomToLayerExtent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
LeafletMap.defaultProps = {
  zoomLayer: ''
};
var _default = LeafletMap;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LeafletMap, 'LeafletMap', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LeafletMap.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/LeafletMap.jsx');
}();

;

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(293);




var copy = '';

var About = function About() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'About' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      null,
      'About this map'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'about__copy', dangerouslySetInnerHTML: { __html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* sanitize */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["b" /* marked */])(copy)) } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'ForestMapper'
      ),
      ' Features:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Robust Science'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'ForestMapper'
      ),
      ' is comprised of 36 geospatial data layers that visually identify the world\'s ancient and endangered forests*. This is a tool developed by Canopy that coalesces data from:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Leading biodiversity science institutions'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Academic institutions'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Environmental non-governmental organizations'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Forest industry working groups'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Suggestions to Identify Supply Chain Risk'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'ForestMapper'
      ),
      ' is designed to: '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Assist companies transitioning to more sustainable supply chains and purchasing practices.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Help identify areas of potential sourcing risk. This tool is not intended to be used as a last point of information.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Ways to Learn More'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Visit ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: 'https://canopyplanet.org/tools/ForestMapper' },
        'canopyplanet.org/tools/ForestMapper'
      ),
      ' to learn more about:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Interactive ways to explore ForestMapper'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'ForestMapper methodology and science'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Full list of company adopters and scientific supporters'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Clarity on what the maps are and are not'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        null,
        'Actions you can take for the world\'s forests'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fineprint' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          '*'
        ),
        ' A landscape will show up as ancient and endangered forest if at least one of the ecological components is present in the area, this could be, for example, a high level of soil carbon or threatened bird species.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Development of ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'ForestMapper'
        ),
        ' has been solely under the control of Canopy and not of the tool\'s collaborators, endorsers, or adopters.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Interactive map development and design by GreenInfo Network'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'greeninfo', alt: 'greeninfo network logo', src: './assets/images/greeninfo-logo.png' })
    )
  );
};

var _default = About;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(copy, 'copy', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/About.jsx');

  __REACT_HOT_LOADER__.register(About, 'About', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/About.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/About.jsx');
}();

;

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import PropTypes from 'prop-types';

var GlobalDeforestationFrontsContent = function (_Component) {
  _inherits(GlobalDeforestationFrontsContent, _Component);

  function GlobalDeforestationFrontsContent() {
    _classCallCheck(this, GlobalDeforestationFrontsContent);

    return _possibleConstructorReturn(this, (GlobalDeforestationFrontsContent.__proto__ || Object.getPrototypeOf(GlobalDeforestationFrontsContent)).apply(this, arguments));
  }

  _createClass(GlobalDeforestationFrontsContent, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        { className: "gdf" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "h4",
          null,
          "Degradation versus Deforestation"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "p",
          null,
          "Deforestation is the conversion of forests to other land uses \u2013 globally, agriculture is the single leading factor. Most deforestation happens in tropical rainforests, as can be seen by this \"deforestation fronts\" data layer. However, the degradation of forests also poses a threat to forests \u2013 this is when the structure of a forest is disturbed and diminished through the removal of specific plant or tree species to the extent it can no longer provide its full range of ecological services. In temperate and Boreal forests, industry logging is a primary driver of forest degradation."
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "six columns" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              null,
              "Deforestation"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { alt: "deforestation", src: "./assets/images/deforestation.jpg" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "six columns" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "h5",
              null,
              "Degradation"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { alt: "degradation", src: "./assets/images/degradation.jpg" })
          )
        )
      );
    }
  }]);

  return GlobalDeforestationFrontsContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _default = GlobalDeforestationFrontsContent;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GlobalDeforestationFrontsContent, "GlobalDeforestationFrontsContent", "/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/GlobalDeforestationFrontsContent.jsx");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/GlobalDeforestationFrontsContent.jsx");
}();

;

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Metadata__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__About__ = __webpack_require__(302);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








__WEBPACK_IMPORTED_MODULE_2_react_modal___default.a.setAppElement('#root');

var Lightbox = function (_Component) {
  _inherits(Lightbox, _Component);

  function Lightbox() {
    _classCallCheck(this, Lightbox);

    return _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).apply(this, arguments));
  }

  _createClass(Lightbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          closeLightbox = _props.closeLightbox,
          referrer = _props.referrer,
          payload = _props.payload;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_modal___default.a,
        {
          isOpen: isOpen,
          contentLabel: 'temp...',
          className: 'Lightbox',
          overlayClassName: 'LightboxOverlay',
          onRequestClose: closeLightbox
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'lightbox__content' },
          referrer === 'dataLayer' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Metadata__["a" /* default */], _extends({}, payload, { closeLightbox: closeLightbox })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__About__["a" /* default */], { closeLightbox: closeLightbox })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'lightbox__close', onClick: function onClick() {
              return closeLightbox();
            } },
          '×'
        )
      );
    }
  }]);

  return Lightbox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Lightbox.propTypes = {
  closeLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  referrer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({})
};
Lightbox.defaultProps = {
  referrer: '',
  payload: {}
};
var _default = Lightbox;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Lightbox, 'Lightbox', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/Lightbox.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/Lightbox.jsx');
}();

;

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_aef_sources_json__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_aef_sources_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__data_aef_sources_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GlobalDeforestationFrontsContent__ = __webpack_require__(303);





var Metadata = function Metadata(props) {
  var name = props.name,
      description = props.description,
      source = props.source,
      sourceurl = props.sourceurl,
      fullcitation = props.fullcitation;


  var metadata_class = name && name.toLowerCase().indexOf('global deforestation fronts') !== -1 ? 'Metadata gdf' : 'Metadata';

  function formatSources() {
    if (name && name.toLowerCase().indexOf('ancient') !== -1) {
      return __WEBPACK_IMPORTED_MODULE_2__data_aef_sources_json___default.a.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'source' },
          item.source,
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: item.sourceurl },
            item.sourceurl
          )
        );
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'source' },
      source || 'no source provided',
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', rel: 'noopener noreferrer', href: sourceurl },
        sourceurl
      )
    );
  }

  function addAdditionalDescriptionContent() {
    if (name && name.toLowerCase().indexOf('global deforestation fronts') !== -1) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GlobalDeforestationFrontsContent__["a" /* default */], null);
    }
    return '';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: metadata_class },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h1',
      null,
      name
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      null,
      'Description'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      description || ''
    ),
    addAdditionalDescriptionContent(),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      null,
      'Source'
    ),
    formatSources(),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      fullcitation || ''
    )
  );
};

Metadata.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sourceurl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fullcitation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

Metadata.defaultProps = {
  description: 'no description provided',
  source: 'no source provided',
  sourceurl: '',
  fullcitation: 'no citation provided'
};

var _default = Metadata;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Metadata, 'Metadata', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/Metadata.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Lightbox/Metadata.jsx');
}();

;

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var ResetLayers = function ResetLayers(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'ResetLayers' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { title: 'Clear all selected layers', onClick: props.handleClick },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'icon icon-reset' })
    )
  );
};

ResetLayers.propTypes = {
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = ResetLayers;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ResetLayers, 'ResetLayers', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/ResetLayers.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/ResetLayers.jsx');
}();

;

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarToggle__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_LayersTabsConnected__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_LayersListConnected__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Instructions__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Footer__ = __webpack_require__(296);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * Class that houses the Sidebar with Layers Tabs and Layers List
 * Uses component state & refs to child components to programatically set the height of Layers List
 * Tracks whether or not the Instructions component's collapsable container is open
 * Uses a React Animation Add-on to smoothly expand / collapse the entire Sidebar
 */

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    // track Instructions height in state, so that when it changes we can re-render;
    // which will update the height of LayersList
    // track whether or not the instructions collapsable container is opened here, so that if the
    // sidebar is expanded and collapsed the instructions stays opened / closed
    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this));

    _this.state = {
      instructionsHeight: null,
      instructionsOpened: true
    };

    // ref to this component
    _this.sidebar = null;

    // callback to pass to Instructions' collapse that will be invoked when its finished animating
    _this.updateInstructionsHeight = _this.updateInstructionsHeight.bind(_this);

    // refs to Footer & LayersTab
    _this.footer = null;
    _this.layersTab = null;

    // function to pass to children to get their ref to store above
    _this.getRef = _this.getRef.bind(_this);
    _this.toggleInstructions = _this.toggleInstructions.bind(_this);
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        // if the Sidebar was previously collapsed and is now open,
        // force a re-render, otherwise the LayersList height won't be set correctly
        this.forceUpdate();
      }
    }
  }, {
    key: 'getRef',
    value: function getRef(ref, type) {
      // we can't just put a ref on the child component instance (that would be too easy!)
      // instead, we have to pass the child component a callback that returns its ref.
      if (type === 'footer') this.footer = ref;
      if (type === 'layersTab') this.layersTab = ref;
    }
  }, {
    key: 'updateInstructionsHeight',
    value: function updateInstructionsHeight(ref) {
      if (ref && ref.offsetHeight !== this.state.instructionsHeight) {
        // height of Instructions component changed, invoke a re-render
        this.setState({
          instructionsHeight: ref.offsetHeight
        });
      }
    }
  }, {
    key: 'computeLayersListHeight',
    value: function computeLayersListHeight() {
      // the LayersList height has to be set programatically as it's dependent on whether or not
      // the Instructions Panel is opened or closed. Very annoying...
      var instructionsHeight = this.state.instructionsHeight;

      if (this.sidebar && this.footer && this.layersTab && instructionsHeight) {
        return this.sidebar.offsetHeight - this.layersTab.offsetHeight - this.footer.offsetHeight - instructionsHeight;
      }

      return null;
    }
  }, {
    key: 'toggleInstructions',
    value: function toggleInstructions() {
      // callback to the Instructions component's open / close button
      this.setState({
        instructionsOpened: !this.state.instructionsOpened
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var instructionsOpened = this.state.instructionsOpened;
      var _props = this.props,
          isOpen = _props.isOpen,
          expandSidebar = _props.expandSidebar,
          collapseSidebar = _props.collapseSidebar,
          openLightbox = _props.openLightbox;
      // programatically calculate the height of the LayersList component

      var layersListHeight = this.computeLayersListHeight();

      // NOTE: the transition time must match that of the CSS transitions in _sidebar.scss as well as
      // _sidebar-toggle.scss in order for this to work correctly
      var transitionTime = 350;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'Sidebar' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SidebarToggle__["a" /* default */], { isOpen: isOpen, expandSidebar: expandSidebar, collapseSidebar: collapseSidebar }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default.a,
          {
            transitionName: 'expand-collapse',
            transitionEnterTimeout: transitionTime,
            transitionLeaveTimeout: transitionTime
          },
          isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'sidebar-container',
              key: 'sidebar-container',
              ref: function ref(_) {
                _this2.sidebar = _;
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_LayersTabsConnected__["a" /* default */], { getRef: this.getRef }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Instructions__["a" /* default */], {
              isOpened: instructionsOpened,
              handleClick: this.toggleInstructions,
              collapseOnRest: this.updateInstructionsHeight
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_LayersListConnected__["a" /* default */], { height: layersListHeight }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Footer__["a" /* default */], { getRef: this.getRef, openLightbox: openLightbox })
          ) : null
        )
      );
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Sidebar.propTypes = {
  appHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  openLightbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  expandSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  collapseSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
var _default = Sidebar;


/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Sidebar, 'Sidebar', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Sidebar.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/Sidebar.jsx');
}();

;

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var SidebarToggle = function SidebarToggle(props) {
  var isOpen = props.isOpen,
      expandSidebar = props.expandSidebar,
      collapseSidebar = props.collapseSidebar;

  var handleClick = isOpen ? collapseSidebar : expandSidebar;

  var toggleClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    SidebarToggle: true,
    collapsed: !isOpen,
    expanded: isOpen
  });

  var spanClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    icon: true,
    collapsed: !isOpen,
    expanded: isOpen
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: toggleClassNames },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { onClick: function onClick() {
          return handleClick();
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: spanClassNames })
    )
  );
};

SidebarToggle.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  expandSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  collapseSidebar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

var _default = SidebarToggle;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SidebarToggle, 'SidebarToggle', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/SidebarToggle.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/components/SidebarToggle.jsx');
}();

;

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(294);





var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      lightbox = _ref.lightbox,
      mapLayers = _ref.mapLayers;
  var height = browser.height,
      width = browser.width;
  var isOpen = lightbox.isOpen;
  var basemap = mapLayers.basemap;

  return {
    appHeight: height,
    appWidth: width,
    basemap: basemap,
    isOpen: isOpen,
    referrer: lightbox.referrer,
    payload: lightbox.payload
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, {
  closeLightbox: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* closeLightbox */],
  openLightbox: __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* openLightbox */],
  toggleBasemap: __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* toggleBasemap */]
})(__WEBPACK_IMPORTED_MODULE_2__components_App__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/AppConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/AppConnected.jsx');
}();

;

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LayersList__ = __webpack_require__(299);





var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var mapLayers = _ref.mapLayers,
      sidebar = _ref.sidebar;
  var height = _ref2.height;
  var dataLayers = mapLayers.dataLayers,
      activeLayers = mapLayers.activeLayers;
  var selectedTab = sidebar.selectedTab;

  return {
    activeLayers: activeLayers,
    dataLayers: dataLayers,
    height: height,
    selectedTab: selectedTab
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, {
  openLightbox: __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* openLightbox */],
  selectMapLayer: __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* selectMapLayer */],
  deselectMapLayer: __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* deselectMapLayer */],
  zoomToLayerExtent: __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* zoomToLayerExtent */]
})(__WEBPACK_IMPORTED_MODULE_2__components_LayersList__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LayersListConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LayersListConnected.jsx');
}();

;

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LayersTabs__ = __webpack_require__(300);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var mapStateToProps = function mapStateToProps(_ref) {
  var mapLayers = _ref.mapLayers,
      sidebar = _ref.sidebar;
  var dataLayers = mapLayers.dataLayers;
  var selectedTab = sidebar.selectedTab;

  // create an array of strings of unique "themes" for the data layers

  var themes = Object.values(dataLayers).reduce(function (arr, cur) {
    var theme = cur.theme;

    if (arr.indexOf(theme) === -1) {
      return [].concat(_toConsumableArray(arr), [theme]);
    }
    return arr;
  }, []);

  return {
    selectedTab: selectedTab,
    themes: themes
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, { selectLayersTab: __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* selectLayersTab */] })(__WEBPACK_IMPORTED_MODULE_2__components_LayersTabs__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LayersTabsConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LayersTabsConnected.jsx');
}();

;

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LeafletMap__ = __webpack_require__(301);





var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      mapLayers = _ref.mapLayers;
  var width = browser.width;
  var isFetchingGeoJson = mapLayers.isFetchingGeoJson,
      activeLayers = mapLayers.activeLayers,
      basemap = mapLayers.basemap,
      dataLayers = mapLayers.dataLayers,
      zoomLayer = mapLayers.zoomLayer;

  return {
    appWidth: width,
    activeLayers: activeLayers,
    basemap: basemap,
    dataLayers: dataLayers,
    isFetchingGeoJson: isFetchingGeoJson,
    zoomLayer: zoomLayer
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, {
  deselectAllMapLayers: __WEBPACK_IMPORTED_MODULE_1__actions__["j" /* deselectAllMapLayers */],
  fetchGeoJsonLayer: __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* fetchGeoJsonLayer */],
  zoomToLayerExtent: __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* zoomToLayerExtent */],
  openLightbox: __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* openLightbox */]
})(__WEBPACK_IMPORTED_MODULE_2__components_LeafletMap__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LeafletMapConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/LeafletMapConnected.jsx');
}();

;

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_CanopyMapLegend__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_CanopyMapLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lib_CanopyMapLegend__);




var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      mapLayers = _ref.mapLayers;
  return {
    width: browser.width,
    activeLayers: mapLayers.activeLayers,
    mapDataLayers: mapLayers.dataLayers
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1__lib_CanopyMapLegend___default.a);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/MapLegendConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/MapLegendConnected.jsx');
}();

;

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__ = __webpack_require__(307);





var mapStateToProps = function mapStateToProps(_ref) {
  var browser = _ref.browser,
      sidebar = _ref.sidebar;
  return {
    appHeight: browser.height,
    isOpen: sidebar.isOpen,
    selectedTab: sidebar.selectedTab
  };
};

var _default = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, { expandSidebar: __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* expandSidebar */], collapseSidebar: __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* collapseSidebar */], openLightbox: __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* openLightbox */] })(__WEBPACK_IMPORTED_MODULE_2__components_Sidebar__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/SidebarConnected.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/containers/SidebarConnected.jsx');
}();

;

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_main_scss__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reduxEntry__ = __webpack_require__(266);





// tell webpack to use our scss



var renderApp = function renderApp(Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_hot_loader__["AppContainer"],
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, null)
  ), document.getElementById('root'));
};

renderApp(__WEBPACK_IMPORTED_MODULE_5__reduxEntry__["a" /* default */]);

if (false) {
  module.hot.accept('./reduxEntry', function () {
    return renderApp(ReduxEntry);
  });
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(renderApp, 'renderApp', '/Users/gin/ginfo/canopyplanet_expert_map/src/index.js');
}();

;

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_thunk__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_logger__);



var middleware = [__WEBPACK_IMPORTED_MODULE_0_redux_thunk___default.a];

if (typeof window !== 'undefined' && "production" !== 'production') {
  // redux-logger only works in a browser environment
  middleware.push(__WEBPACK_IMPORTED_MODULE_1_redux_logger___default.a);
}

var _default = middleware;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(middleware, 'middleware', '/Users/gin/ginfo/canopyplanet_expert_map/src/middleware.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/middleware.js');
}();

;

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_responsive__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lightboxReducer__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapLayersReducer__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebarReducer__ = __webpack_require__(320);







// breakpoints to match Skeleton CSS's
var browser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_responsive__["c" /* createResponsiveStateReducer */])({
  extraSmall: 400,
  small: 550,
  medium: 750,
  large: 1000,
  extraLarge: 1200
}, {
  extraFields: function extraFields() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
});

var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* combineReducers */])({
  browser: browser,
  lightbox: __WEBPACK_IMPORTED_MODULE_2__lightboxReducer__["a" /* default */],
  mapLayers: __WEBPACK_IMPORTED_MODULE_3__mapLayersReducer__["a" /* default */],
  sidebar: __WEBPACK_IMPORTED_MODULE_4__sidebarReducer__["a" /* default */]
});

var _default = rootReducer;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(browser, 'browser', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(rootReducer, 'rootReducer', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/index.js');
}();

;

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(61);


var defaultState = {
  isOpen: false,
  referrer: null,
  payload: null
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["a" /* LIGHTBOX_OPEN */]:
      return {
        isOpen: true,
        referrer: action.referrer,
        payload: action.payload
      };

    case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["b" /* LIGHTBOX_CLOSE */]:
      return {
        isOpen: false,
        referrer: null,
        payload: null
      };

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultState, 'defaultState', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/lightboxReducer.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/lightboxReducer.js');
}();

;

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_data_inventory_json__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_data_inventory_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_data_inventory_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





// URL to the S3 bucket where GeoJSON and tiles are stored


// list of data layers with human readable names mapped to AWS S3 bucket keys


// tile layer xyz
var zxy = '{z}/{x}/{y}.png';

// takes a value like "255, 255, 255" and converts to "rgb(255, 255, 255)"
var parseRgbValue = function parseRgbValue(s) {
  var rgb = s.split(',');
  return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
};

// create a hash / lookup table of data layers
var dataLayers = __WEBPACK_IMPORTED_MODULE_3__data_data_inventory_json___default.a.reduce(function (hash, d) {
  // early return if the layer isn't used in the expert map
  if (!d.expert_map) return hash;
  // store the JSON object as a value of the hash
  hash[d.datacode] = _extends({}, d);
  // if the layer is a tile layer, go ahead and create it, otherwise leave empty bc geojson layer
  if (d.datatype === 'tileLayer') {
    hash[d.datacode].leaflet = __WEBPACK_IMPORTED_MODULE_0_leaflet__["tileLayer"](__WEBPACK_IMPORTED_MODULE_2__common_config__["a" /* s3Url */] + '/' + d.datacode + '/' + zxy, { zIndex: 3 });
  } else if (d.datatype === 'marker') {
    var coords = d.marker_lat_lng.split(',');
    var marker = __WEBPACK_IMPORTED_MODULE_0_leaflet__["marker"](coords);
    // hack: get the marker properties saved on the marker for use elsewhere
    window.ginprop = d;
    marker.properties = d;
    hash[d.datacode].leaflet = marker;
  } else {
    hash[d.datacode].leaflet = null;
  }

  // add a flag to determine if the layer has been selected or not
  hash[d.datacode].selected = __WEBPACK_IMPORTED_MODULE_2__common_config__["b" /* DEFAULT_LAYERS */].indexOf(hash[d.datacode].datacode) !== -1;
  // if it's a geojson layer, create a style property from attributes
  hash[d.datacode].style = d.datatype === 'geojson' ? {
    color: parseRgbValue(d.stroke_color),
    weight: +d.stroke_weight,
    opacity: +d.stroke_opacity,
    fillColor: parseRgbValue(d.fill_color),
    fillOpacity: +d.fill_opacity
  } : null;
  // fill color to use for the legend; not all layers get these as some aren't shown in the legend
  // and some have multiple values (e.g. color ramps)
  hash[d.datacode].legend_fill = d.fill_color ? parseRgbValue(d.fill_color) : null;
  // units to display in the legend, should be a comma separated list
  hash[d.datacode].legend_units = d.legend_units ? d.legend_units.split(',') : null;
  // if it's a marker, parse the lat lng coordinates
  hash[d.datacode].coords = d.datatype === 'marker' ? d.marker_lat_lng.split(',').map(function (e) {
    return +e;
  }) : null;
  // make sure layer list order is actually a number
  hash[d.datacode].listed_order = parseInt(d.listed_order, 10);
  // tile layer opacity value
  hash[d.datacode].tile_opacity = d.datatype !== 'geojson' && d.tile_opacity ? parseFloat(d.tile_opacity, 10) : null;

  return hash;
}, {});

// default Redux reducer state:
// - activeLayers (array of strings): a list of layer ids that have been selected by the user
// - basemap: (string): the current basemap
// - dataLayers (obj): the layer hash created above
// - isFetchingGeoJson (bool): are we requesting a GeoJSON file async?
// - error (obj || string || null): was there an error requesting a GeoJSON file?
// - zoomLayer (string): datacode of layer to zoom to
// - zoomHome (bool): should the map zoom home to original zoom setting
var defaultState = {
  activeLayers: __WEBPACK_IMPORTED_MODULE_2__common_config__["b" /* DEFAULT_LAYERS */],
  basemap: 'watercolor',
  dataLayers: dataLayers,
  isFetchingGeoJson: false,
  error: null,
  zoomLayer: '',
  zoomHome: false
};

// When a user deselects all map layers we need to iterate over the layer hash and set selected to
// false. This happens when the reducer intercepts the DESELECT_ALL_MAP_LAYERS action
function deselectAllDataLayers(oldDataLayers) {
  var newDataLayers = _extends({}, oldDataLayers);

  Object.keys(newDataLayers).forEach(function (key) {
    newDataLayers[key].selected = false;
  });

  return newDataLayers;
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["g" /* SELECT_MAP_LAYER */]:
      // add the layer id to the activeLayers list
      // flip the selected flag of the layer to true
      return _extends({}, state, {
        activeLayers: [].concat(_toConsumableArray(state.activeLayers), [action.layer]),
        dataLayers: _extends({}, state.dataLayers, _defineProperty({}, action.layer, _extends({}, state.dataLayers[action.layer], {
          selected: true
        })))
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["h" /* DESELECT_MAP_LAYER */]:
      // remove the layer id from the activeLayers list
      // flip the selected flag of the layer to false
      return _extends({}, state, {
        activeLayers: state.activeLayers.filter(function (layer) {
          return action.layer !== layer;
        }),
        dataLayers: _extends({}, state.dataLayers, _defineProperty({}, action.layer, _extends({}, state.dataLayers[action.layer], {
          selected: false
        })))
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["i" /* DESELECT_ALL_MAP_LAYERS */]:
      return _extends({}, state, {
        activeLayers: [],
        dataLayers: deselectAllDataLayers(state.dataLayers)
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["f" /* TOGGLE_BASEMAP */]:
      return _extends({}, state, {
        basemap: action.basemap
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["j" /* ZOOM_TO_MAP_HOME */]:
      return _extends({}, state, {
        zoomHome: !state.zoomHome
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["k" /* ZOOM_TO_MAP_LAYER_EXTENT */]:
      return _extends({}, state, {
        zoomLayer: action.layer
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["l" /* GEOJSON_LAYER_REQUEST */]:
      return _extends({}, state, {
        isFetchingGeoJson: true
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["m" /* GEOJSON_LAYER_SUCCESS */]:
      // on a successful GeoJSON request for a given vector layer
      // instantiate a Leaflet geoJson layer with the response GeoJSON
      return _extends({}, state, {
        isFetchingGeoJson: false,
        dataLayers: _extends({}, state.dataLayers, _defineProperty({}, action.layer, _extends({}, state.dataLayers[action.layer], {
          leaflet: __WEBPACK_IMPORTED_MODULE_0_leaflet__["geoJson"](action.json)
        })))
      });

    case __WEBPACK_IMPORTED_MODULE_1__common_actionTypes__["n" /* GEOJSON_LAYER_ERROR */]:
      return _extends({}, state, {
        error: action.error
      });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(zxy, 'zxy', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');

  __REACT_HOT_LOADER__.register(parseRgbValue, 'parseRgbValue', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');

  __REACT_HOT_LOADER__.register(dataLayers, 'dataLayers', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');

  __REACT_HOT_LOADER__.register(defaultState, 'defaultState', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');

  __REACT_HOT_LOADER__.register(deselectAllDataLayers, 'deselectAllDataLayers', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/mapLayersReducer.js');
}();

;

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__ = __webpack_require__(61);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaultState = {
  selectedTab: 'forests',
  isOpen: true
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["c" /* SELECT_LAYERS_TAB */]:
      return _extends({}, state, {
        selectedTab: action.tab
      });

    case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["d" /* SIDEBAR_EXPAND */]:
      return _extends({}, state, {
        isOpen: true
      });

    case __WEBPACK_IMPORTED_MODULE_0__common_actionTypes__["e" /* SIDEBAR_COLLAPSE */]:
      return _extends({}, state, {
        isOpen: false
      });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultState, 'defaultState', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/sidebarReducer.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/reducers/sidebarReducer.js');
}();

;

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_responsive__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers___ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(316);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








// This configures our Redux "store", the part of Redux that handles storing application state
// it includes middleware, such as redux-thunk and redux-logger, see the docs for more info:
// http://redux.js.org/docs/advanced/Middleware.html
function makeStore(initialState) {
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_3__reducers___["a" /* default */], initialState, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_responsive__["a" /* createResponsiveStoreEnhancer */])(500), // throttle time
  __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* applyMiddleware */].apply(undefined, _toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__middleware__["a" /* default */]))));

  if (false) {
    // Enable Webpack's "hot module replacement" for Redux reducers
    module.hot.accept('./reducers', function () {
      // eslint-disable-next-line
      var nextReducer = require('./reducers/index').default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

var store = makeStore({});

// fire redux-responsive on window resize event
window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
  return store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_responsive__["b" /* calculateResponsiveState */])(window));
}, 150));

var _default = store;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(makeStore, 'makeStore', '/Users/gin/ginfo/canopyplanet_expert_map/src/store.js');

  __REACT_HOT_LOADER__.register(store, 'store', '/Users/gin/ginfo/canopyplanet_expert_map/src/store.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/gin/ginfo/canopyplanet_expert_map/src/store.js');
}();

;

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports = [
	{
		"source": "For more information on the methodology, please consult The Science behind Forest Mapper:",
		"sourceurl": "https://www.canopyplanet.org/tools/forestmapper/sciencebehind"
	},
	{
		"source": "There are 25 \"core\" datasets and foundational frameworks that went into making the Ancient and Endangered composite dataset, excluding the background and administrative data, which are excluded from this list. The sources below were last accessed on December 15, 2015."
	},
	{
		"source": "Intact forest landscapes (2013; 2010). Greenpeace, University of Maryland, World Resources Institute and Transparent World. \"Intact Forest Landscapes. 2000/2013\" (2013 globally; 2013 Indonesia; 2010 Canada)",
		"sourceurl": "http://data.globalforestwatch.org/datasets/ab914731bbd04a2298354d71dc5a9f62_0"
	},
	{
		"source": "Intact forest landscapes for Indonesia (2013):",
		"sourceurl": "http://data.globalforestwatch.org/datasets/b3ac8839275446b5983c0271fddf1e33"
	},
	{
		"source": "Intact forest landscapes for Canada (2010):",
		"sourceurl": "https://databasin.org/galleries/0267510a7beb4142a55857290b8f922a#expand=152261"
	},
	{
		"source": "Priority forest ecoregions - (WWFs Global 200) (2002). World Wildlife Fund. Priority Forest Ecoregions. Ecoregions of the World (Global 200) 2002. Accessed through:",
		"sourceurl": "http://databasin.org/datasets/a5b34649cc69417ba52ac8e2dce34c3b"
	},
	{
		"source": "Biologically rich and deeply threatened forested hotspots (Conservation International) (2014). Conservation International. 2011. Biodiversity Hotspots. Accessed through:",
		"sourceurl": "https://www.globalforestwatch.org"
	},
	{
		"source": "Temperate and Boreal Rainforests (2011). Henrik vonWehrden in DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp. Accessed through:",
		"sourceurl": "http://databasin.org/maps/96307c4ce4284ad99ba3dee3be506492"
	},
	{
		"source": "Species diversity hotspots (mammals, birds, amphibians) (2015). Hotspots of species diversity and richness (mammals, birds, amphibians). 2015. BiodiversityMapping.org, BirdLife International, IUCN, and NatureServe Biodiversity. (original source) http://www.biodiversitymapping.org/download.htm. Accessed through:",
		"sourceurl": "http://databasin.org/datasets/bdc972049e0f476481e2c1f572fe7eeb"
	},
	{
		"source": "Global Vegetation biomass – carbon stocks - 1km  - resolution (2010). Ruesch, Aaron, and Holly K. Gibbs. 2008. New IPCC Tier-1 Global Biomass Carbon Map For the Year 2000. Accessed through:",
		"sourceurl": "https://databasin.org/datasets/2d7ed4b20ed2439f8ba3d2976d6aa801"
	},
	{
		"source": "Sumatran tiger (1995-2005). Wildlife Conservation Society, World Wildlife Fund, Smithsonian Institution, Save the Tiger Fund. 2006. Accessed through:",
		"sourceurl": "https://databasin.org/datasets/213f9dfd508945dd88eff1e1787f3564"
	},
	{
		"source": "Sumatran Rhinoceros (2011). Wahab, A., J. Payne, A. Mohamed, C. Lau, D. Sharma, R. Amirtharaj, S. Nathan, W. Ramono and G. Clements. 2011. Now or never: what will it take to save the Sumatran rhinoceros Dicerorhinus sumatrensis from extinction? Borneo Rhino Alliance. Fauna & Flora International, Oryx, 45(2), 225–233. Canopy digitized the 2011 Sumatran Rhinoceros population range from Figure 1 in the source publication. Available at:",
		"sourceurl": "http://www.borneorhinoalliance.org/wp- content/uploads/2014/02/Abdul_Wahab_et_al_2011.pdf"
	},
	{
		"source": "Javan Rhinoceros (1997). Thomas J. and van Strien, Nico. 1997, Asian Rhinos – Status Survey and Conservation Action Plan. IUCN, Gland, Switzerland, and Cambridge, UK, ISBN 2-8317-0336-0 (available at: http://www.rhinoresourcecenter.com/pdf_files/117/1175857641.pdf) Accessed through:",
		"sourceurl": "https://commons.wikimedia.org/wiki/File:Javan_Rhino_Range.svg"
	},
	{
		"source": "Sumatran elephant (2012). Watts, Jonathan. 2012. Sumatran elephant upgraded to critically endangered status. World Wildflie Fund. Canopy digitized the 2008 Sumatran elephant population range from the World Wildlife Fund, Decline of the Sumatran elephant map featured in The Guardian on January 24, 2012.",
		"sourceurl": "http://www.theguardian.com/environment/2012/jan/24/sumatran-elephant-upgraded-critically-endangered"
	},
	{
		"source": "Borneo elephant (2010). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Further information can be found at:",
		"sourceurl": "http://www.soselephants.com/borneo-elephants.html"
	},
	{
		"source": "Java leopard (2011). Gunawan, H., L. Prasetyo, A. Mardiastuti, A. Kartano. 2011. Habitat Suitability of Javan Leopard in Central Java Landscape. Institut Pertanian Bogor. Poster. Canopy digitized the 2011 Java leopard population range. Accessed through:",
		"sourceurl": "http://lbprastdp.staff.ipb.ac.id/files/2011/12/POSTER_HABITAT_SUITABILITY_OF_JAVAN_LEOPARD__EDITED_.pdf"
	},
	{
		"source": "Sumatran Orangutan (2012). UNEP-WCMC and IUCN. 2015. Pongo abelii. The IUCN Red List of Threatened Species. Version 2012.1. Accessed through:",
		"sourceurl": "http://maps.iucnredlist.org/map.html?id=121097935"
	},
	{
		"source": "Indonesia peatlands (2010). Saxon, Earl and Stu Sheppard. 2010. Land Systems of Indonesia and Papua New Guinea.  Accessed through the following (from Land Systems of Indonesia and New Guinea, extract 02 Wetlands and Swamps):",
		"sourceurl": "http://databasin.org/datasets/eb74fe29b6fb49d0a6831498b0121c99"
	},
	{
		"source": "Leuser Ecosystem (date unknown). Accessed through:",
		"sourceurl": "http://data.globalforestwatch.org/datasets/16dae98167264b8abfbd13e23802e4f3_0"
	},
	{
		"source": "Primary Forests. This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Accessed through:",
		"sourceurl": "http://data.globalforestwatch.org/datasets/b3ac8839275446b5983c0271fddf1e33 (Indonesia primary forests [2000]) "
	},
	{
		"source": "Tropical forest carbon stocks (2000). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Accessed through the following, using Tropical forest carbon stocks (2000): ",
		"sourceurl": "http://data.globalforestwatch.org/datasets/bb7efe571e344aa6a42882803f73685f"
	},
	{
		"source": "Woodland Caribou (2010). Environment Canada, 2010. Dataset no longer available externally. ",
		"sourceurl": ""
	},
	{
		"source": "Southern and Northern Mountain Caribou (2012). Environment Canada. 2014. Recovery Strategy for the Woodland Caribou, Southern Mountain population (Rangifer tarandus caribou) in Canada [Proposed]. Species at Risk Act Recovery Strategy Series. Environment Canada, Ottawa. viii + 68 pp. Accessed through:",
		"sourceurl": "http://www.sararegistry.gc.ca/virtual_sara/files/plans/mp_woodland_caribou_northern_mountain_population_e.pdf"
	},
	{
		"source": "Southern and Northern Mountain Caribou (2012). Additional information accessed through:",
		"sourceurl": "http://www.sararegistry.gc.ca/virtual_sara/files/plans/rs_woodland_caribou_bois_s_mtn_pop_0114_e.pdf"
	},
	{
		"source": "Forest Age (2004). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. NCAP Forest Age Maps at 1-km Resolution for Canada (2004) and the United States (2006). Pan, Y., Chen, J. M., Birdsey, R., McCullough, K., He, L., and Deng, F.: Age structure and disturbance legacy of North American forests, Biogeosciences, 8, 715-732, doi:10.5194/bg-8-715-2011, 2011.  Accessed through:",
		"sourceurl": "https://webmap.ornl.gov/wcsdown/dataset.jsp?ds_id=1096"
	},
	{
		"source": "Ducks Unlimited Hydrid Wetlands (2010 ). Data is available on request from Ducks Unlimited. ",
		"sourceurl": "https://www.ducks.ca/about/contact/"
	},
	{
		"source": "Soil Organic Carbon (1995). This dataset was utilized for general and important context information only, and is not displayed on the Ancient and Endangered Forests Map. Further analysis or higher quality data on this topic may need to be acquired. Soil Carbon of Canada Database accessed through:",
		"sourceurl": "http://sis.agr.gc.ca/cansis/interpretations/carbon/index.html"
	},
	{
		"source": "FRAMEWORKS"
	},
	{
		"source": "Forest Stewardship Council. High Conservation Value Forest Assessment Framework. Revised draft, 2010. Accessed Sept 11, 2017:",
		"sourceurl": "https://us.fsc.org/preview.fsc-us-hcvf-assessment-framework.a-190.pdf"
	},
	{
		"source": "Forest Stewardship Council: FSC Board of Directors. 2015. International Generic Indicators FSC-STD-60-004 V1.0. Available at:",
		"sourceurl": "http://igi.fsc.org/approved-documents.60.htm"
	},
	{
		"source": "Wye Group discussion document. 2002. Endangered Forests: Priority High Conservation Value Forests for Protection Guidance for Corporate Commitments Forest Leadership Forum: Collaborative Pathways to Responsible Trade April 25-27, 2002, Cobb Galleria, Atlanta Georgia. Accessed Sept. 11, 2017.",
		"sourceurl": "http://www.greenpeace.org/usa/research/endangered-forests-definition/"
	},
	{
		"source": "Ecological Components of Endangered Forests. April 2006. ForestEthics, Greenpeace, Natural Resources Defense Council, and Rainforest Action Network. Available at",
		"sourceurl": "http://www.greenpeace.org/wp-content/uploads/legacy/Global/usa/report/2010/2/endangered-forests-technical-d.pdf"
	},
	{
		"source": "The HCS Approach Toolkit: Putting No Deforestation in Practice. Version 1.0 March 2015. Available at:",
		"sourceurl": "http://highcarbonstock.org/the-hcs-approach-toolkit/"
	}
];

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = [
	{
		"datacode": "biodiversity_hotspots",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Biodiversity Hotspots",
		"shortdescription": "Regions with high levels of endemism and human threat.",
		"description": "Conservation International defined 35 biodiversity hotpsots around the world where biodiversity conservation is most urgent because of high levels of endemism and human threat.",
		"source": "Conservation International, 2011. \"Biodiversity hotspots.\" Accessed through Global Forest Watch on July 18, 2017: ",
		"sourceurl": "http://www.globalforestwatch.org",
		"fullcitation": null,
		"fill_color": "255, 255, 190",
		"fill_opacity": "1",
		"stroke_color": "255, 255, 0",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "6",
		"tile_opacity": null
	},
	{
		"datacode": "birds_richness_all_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Bird Species Richness",
		"shortdescription": "Bird Species Richness (2018).",
		"description": "Species richness refers to the diversity of bird species in a measured area. Primary bird species range-map data used to create the diversity maps on BiodiversityMapping.org are from BirdLife International and NatureServe. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps for all the world's birds in BirdLife International and NatureServe (2018)",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,677.8",
		"legend_units_label_single": "Number of Bird Species",
		"legend_units_label": null,
		"listed_order": "9",
		"tile_opacity": null
	},
	{
		"datacode": "birds_threatened_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Threatened Birds",
		"shortdescription": "Threatened Birds (2018).",
		"description": "Threatened in this case refers to birds that are vulnerable, endangered, or critically endangered (IUCN). Threatened bird species range-map data used to create the diversity maps on BiodiversityMapping.org are from BirdLife International and NatureServe. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps for all the world's birds in BirdLife International and NatureServe (2018)",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,31.2",
		"legend_units_label_single": "Number of Bird Species",
		"legend_units_label": null,
		"listed_order": "10",
		"tile_opacity": null
	},
	{
		"datacode": "boreal",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Global Boreal Forest Extent",
		"shortdescription": "Boreal/Taiga Forest extent.",
		"description": "This data layer represents the northern extent of the Boreal forest, worldwide. The Boreal extent includes the closed-canopy forest and the taiga (which consists of lichen woodland and forest tundra). The closed-canopy forest is the southernmost portion, contains the greatest richness of species and  has the longest growing season within the boreal zone. North of the closed-canopy forest is the taiga, a zone that ranges from sparse forest in which tree crowns do not form a closed canopy to patches of trees consisting of only a few species that populate certain portions of the landscape. The data layer was derived from The Nature Conservancy’s Global Ecoregions, Major Habitat Types, Biogeographical Realms and The Nature Conservancy Terrestrial Assessment Units as of December 14, 2009. To better identify the North American Boreal, the Natural Resource Canada dataset (called North American Boreal Forest Extent) presented in the next map should be used, as it is the one most currently accepted for that region of the world.",
		"source": "Boreal/Taiga Forest Extent from The Nature Conservancy Terrestrial Ecoregions. Accessed Aug 08, 2017.",
		"sourceurl": "http://maps.tnc.org/gis_data.html",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": "0.4",
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "5",
		"tile_opacity": "0.4"
	},
	{
		"datacode": "boreal_caribou_range_June62012",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Caribou Distribution",
		"shortdescription": "Boreal Woodland Caribou Range (2012).",
		"description": "This dataset was compiled by the Environment Canada's Science and Technology Division. It illustrates the occurrence of woodland caribou (rangifer tarandus caribou, forest-dwelling ecotype) across Canada as depicted in the National Recovery Strategy, based on information provided by provincial and territorial jurisdictions to Environment Canada and interpreted from 2008-2010 Landsat satellite imagery, updated to 2012 range boundaries.",
		"source": "Boreal Woodland Caribou (forest-dwelling ecotype) Occurrence in Canada, Environment Canada's Science and Technology Division. January 01, 2013. Accessed January 13, 2020",
		"sourceurl": "https://open.canada.ca/data/en/dataset/890a5d8d-3dbb-4608-b6ce-3b6d4c3b7dce",
		"fullcitation": "Environment Canada's Science and Technology Division, Anthropogenic disturbance footprint within boreal caribou ranges across Canada - As interpreted from 2008-2010 Landsat satellite imagery Updated to 2012 range boundaries, January 01, 2013. Accessed January 13, 2020",
		"fill_color": "255, 170, 0",
		"fill_opacity": "0.4",
		"stroke_color": "230, 152, 0",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "5",
		"tile_opacity": null
	},
	{
		"datacode": "boreal_na",
		"datatype": "tileLayer",
		"theme": null,
		"layerlabel": "North America Boreal Forest Extent",
		"shortdescription": "North American Boreal Forest Extent.",
		"description": "The circumpolar boreal zone is one of the world’s major biogeoclimatic zones, covering much of North America and Eurasia with forests, woodlands, wetlands, and lakes. It regulates climate, acts as a reservoir for biological and genetic diversity, plays a key role in biogeochemical cycles, and provides renewable resources, habitat, and recreational opportunities. Poor agreement exists amongst scientists regarding this zone’s delimitation and the areal extent of boreal forests, even though the zone has been well-studied. This paper reviews the literature on the phytogeography of the zone and makes use of a geographic information system (GIS) and published maps to delineate a current map of the North American boreal zone and the hemiboreal subzone, which is a transitional area lying immediately to the south of the boreal zone that is usually included in the boreal zone by Europeans but excluded by North Americans. On the basis of the map described here, the boreal zone covers about 627 million ha, or 29% of the North American continent north of Mexico. If the hemiboreal subzone, at 116 million ha, is included, then 34% of the same area is covered. Forests and other wooded land (362 million ha) cover 58% of the North American boreal zone on the basis of current forest inventory data. With forests and other wooded land of the hemiboreal subzone (68 million ha) factored in, this percentage remains basically unchanged. Values reported in this paper are compared with other published statistics. Important sources of error contributing to differences in areal statistics are discussed.",
		"source": "Citation : Brandt, J. P. Natural Resources Canada, The Extent of the North America Boreal Zone Environmental Reviews, 2009, 17(NA): 101-161.",
		"sourceurl": "https://doi.org/10.1139/A09-004",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": "0.4",
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": null,
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "6",
		"tile_opacity": "0.4"
	},
	{
		"datacode": "broadback_hotspot",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Broadback Watershed Boundary",
		"shortdescription": "Watershed extent of the Broadback River.",
		"description": "As of 2015, two thirds of the Broadback Forest, an intact forest landscape in Canada's Boreal Forest in the province of Quebec, is officially protected. Protection such as this is of critical importance for human communities, the bird and animal species that rely on the forest, and the ecological services they provide. Conservation for the remaining third of the area is proposed for protection, and is crucial to maintaining biodiversity, viable caribou habitat, and the local First Nations way of life.",
		"source": "Broadback River Watershed in Time-series Analyses of Change in Broadback River Watershed and Adjacent Area. 2016. Global Forest Watch Canada. Accessed through CARTO, Sept 27, 2017: ",
		"sourceurl": "https://gfwcbroadback.carto.com/tables/broadback_watershed/public ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "carbon_density",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Forest Carbon Density",
		"shortdescription": "Aboveground forest carbon biomass density (2016).",
		"description": "Forest biomass density plays a large role in estimating the carbon storage potential of forests. Biomass is biological material derived from living or recently living organisms. Carbon density values can be estimated as 50 percent of biomass density values, though data presented here should not be used for official assessments. This is the first global biomass map based on field observations and remote sensing data to assess the aboveground biomass of woody vegetation at 0.01 degree resolution. The map covers only forest areas, where forests are defined as areas with dominance of tree cover in the GLC2000 map (Bartholomé and Belward, 2005).",
		"source": "Avitabile, V., Herold, M., Heuvelink, G., Lewis, S.L., Phillips, O.L., Asner, G.P. et al. (2016). Accessed, July 24 2017: ",
		"sourceurl": "http://www.wur.nl/en/Expertise-Services/Chair-groups/Environmental-Sciences/Laboratory-of-Geo-information-Science-and-Remote-Sensing/Research/Integrated-land-monitoring/Forest_Biomass.htm",
		"fullcitation": "Avitabile V., Herold, M., Heuvelink, G., Lewis, S.L., Phillips, O.L., Asner, G.P. et al. (2016). An integrated pan-tropical biomass map using multiple reference datasets. Global Change Biology, 22: 1406-1420. doi:10.1111/gcb.13139.",
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "675, 37850",
		"legend_units_label_single": "0.01 tons biomass C/hectare",
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "carbon_density_boreal",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Forest Carbon Density Boreal",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": "675, 37850",
		"legend_units_label_single": "0.01 tons biomass C/hectare",
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "ee_broadback_marker",
		"datatype": "marker",
		"theme": "earth engine map marker",
		"layerlabel": "ee_broadback_marker",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "50.35158,-73.56894",
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "elephant_merge_03022020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Elephant Distribution",
		"shortdescription": "Sumatran Elephant habitat range (2008).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran elephant (elephas maximus sumatrensis) has been placed on the list of critically endangered species after losing half of its population in a single generation, prompting calls from conservation groups for emergency measures to halt the destruction of its habitat. Canopy digitized the 2008 Sumatran elephant population range from the World Wildlife Fund, Decline of the Sumatran elephant map featured in The Guardian on January 24, 2012. This file was merged with the Sumatran extent of the Elephas maximus range provided by IUCN.",
		"source": "The Decline of the Sumatran Elephant,\" map based on World Wildlife Fund data, in Watts, Jonathan. 2012. Sumatran elephant upgraded to critically endangered status. The Guardian. Digitized August, 2017. Merged with Sumatran extent of Elephas maximus (Asian Elephant) data provided by IUCN. Last assessed June 30, 2008; accessed January 6, 2020.",
		"sourceurl": "https://www.theguardian.com/environment/2012/jan/24/sumatran-elephant-upgraded-critically-endangered; https://www.iucnredlist.org/species/7140/12828813",
		"fullcitation": "IUCN: Choudhury, A., Lahiri Choudhury, D.K., Desai, A., Duckworth, J.W., Easa, P.S., Johnsingh, A.J.T., Fernando, P., Hedges, S., Gunawardena, M., Kurt, F., Karanth, U., Lister, A., Menon, V., Riddle, H., Rübel, A. & Wikramanayake, E. (IUCN SSC Asian Elephant Specialist Group) 2008. Elephas maximus . The IUCN Red List of Threatened Species 2008: e.T7140A12828813. https://dx.doi.org/10.2305/IUCN.UK.2008.RLTS.T7140A12828813.en. Downloaded on 06 January 2020.",
		"fill_color": "255, 255, 0",
		"fill_opacity": "0.6",
		"stroke_color": "104, 104, 104",
		"stroke_weight": "0.1",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "global_aef",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Ancient and Endangered Forests",
		"shortdescription": "Forest landscapes containing high ecological value and high levels of threat.",
		"description": "This dataset identifies the characteristics and locations of Ancient and Endangered Forests (AEF) around the world. The AEF layer is a composite of 25 core geospatial datasets representing key ecological characteristics of high value forests available at global scales. Our definition of AEF and the selection of the core datasets is based on the latest frameworks for defining Ancient and Endangered Forests from leading biodiversity and conservation scientists and environmental non-governmental organizations. \n\nIn this application, AEF is defined as: intact forest landscape mosaics, naturally rare forest types, forest types that have been made rare due to human activity, forests with high species richness, forests containing high concentrations of rare and endangered species, forests of high endemism, core habitat for focal species, or forests exhibiting rare ecological and evolutionary phenomena. \n\nThe Ancient and Endangered Forest landscapes presented in ForestMapper do not comprise all of the ecological components and values identified in our definition, but rather present the landscapes that contain at least one of the core components or values associated with the AEF definition. This ensures that all potential ecologically important forests are represented and that no critical areas – from an ecological standpoint – are overlooked. ",
		"source": null,
		"sourceurl": "http://canopyplanet.org/tools/forestmapper/methods-references/#sources",
		"fullcitation": null,
		"fill_color": "0, 109, 44",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "great_bear_rainforest",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Great Bear Rainforest Boundary",
		"shortdescription": "Strategic Land and Resources Plan boundaries, 2016.",
		"description": "This dataset is the combination of Schedule B boundary for the Central and North Coast and the Schedule C boundary for the South Central Coast areas of the Great Bear Rainforest.",
		"source": "ohn Sunde, Jan 2016. Schedule B and Schedule C boundaries of the Great Bear Rainforest. British Columbia Ministry of Forests, Lands, and Natural Resource Operations. Accessed June 6, 2017 through",
		"sourceurl": " https://www.for.gov.bc.ca/tasb/slrp/plan17.html ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "hotspot_points",
		"datatype": "geojson",
		"theme": "canopy map marker",
		"layerlabel": "hotspot_points",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "canopy_map_marker",
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "ifl_gfwc_2016_02122020",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Intact Forest Landscapes",
		"shortdescription": "Unfragmented forest landscapes (2016).",
		"description": "Identifies the world’s last remaining unfragmented forest landscapes of at least 50,000 hectares in size, and with a minimum width of ten kilometers, large enough to retain all native biodiversity and showing no signs of human alteration as of the year 2016. The world IFL (Intact Forest Landscapes) map was created through visual interpretation of Landsat images by experts. The map may contain inaccuracies due to limitations in the spatial resolution of the imagery and lack of ancillary information about local land-use practices in some regions. In addition, the methodology assumes that fires in proximity to roads or other infrastructure may have been caused by humans, and therefore constitute a form of anthropogenic disturbance. This assumption could result in an underestimation of IFL extent in the boreal biome.",
		"source": "University of Maryland, Wildlife Conservation Society, Greenpeace, and Transparent World. \"Intact Forest Landscapes. 2016\" Accessed through Intact Forest Landscapes on January 6, 2020",
		"sourceurl": "http://www.intactforests.org/data.ifl.html",
		"fullcitation": "Potapov P., Yaroshenko A., Turubanova S., Dubinin M., Laestadius L., Thies C., Aksenov D., Egorov A., Yesipova Y., Glushkov I., Karpachevskiy M., Kostikova A., Manisha A., Tsybikova E., Zhuravleva I. 2008. Mapping the World's Intact Forest Landscapes by Remote Sensing. Ecology and Society, 13 (2)",
		"fill_color": "255,84,131",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "2",
		"tile_opacity": null
	},
	{
		"datacode": "ind_leuser_ecosys",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Leuser Boundary",
		"shortdescription": "Leuser Ecosystem boundary.",
		"description": "The Leuser Ecosystem spans the provinces of Aceh and North Sumatra on the Island of Sumatra in Indonesia. This majestic and ancient ecosystem covers more than 2.6 million hectares of lowland rainforests, peat swamps, montane and coastal forests, and alpine meadows. Globally recognized as one of the richest expanses of tropical rainforest found anywhere in Southeast Asia, the Leuser Ecosystem is also one of Asia's largest carbon sinks. The data displayed in this map is not official data from the Indonesian Ministry of Environment and Forestry. As a result, this data may differ from official data and there may be inaccuracies.",
		"source": "Hutan Alam dan Lingkungan Aceh (HAKA). Nov. 19, 2013. Indonesia Leuser Ecosystem. Accessed through Global Forest Watch Nov. 23, 2015: ",
		"sourceurl": "http://data.globalforestwatch.org/datasets/16dae98167264b8abfbd13e23802e4f3_0",
		"fullcitation": null,
		"fill_color": "156, 156, 156",
		"fill_opacity": "0.4",
		"stroke_color": "104, 104, 104",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "ind_rhino",
		"datatype": "marker",
		"theme": "species",
		"layerlabel": "Rhino Distribution",
		"shortdescription": "Sumatran Rhino range.",
		"description": "The data layer representing habitat range of the Sumatran Rhinoceros has been removed from view and replaced with a non-site specific shape in this section of ForestMapper due to concerns that this level of site-specific visual reference could potentially be used by poachers to locate and hunt these critically endangered species. The data from these layers still exists in the combined Ancient and Endangered Forest layer of ForestMapper. The Sumatran rhinoceros, elephants, and tigers range and/or habitat are therefore included in the Ancient and Endangered Forest data layer. Read more about each species in the Information box beside their name.",
		"source": "For further information, contact Canopy directly.",
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "3.821179,97.556794",
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "mammals_richness_all_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Mammal Species Richness",
		"shortdescription": "Mammal Species Richness (2018).",
		"description": "Species richness refers to the diversity of mammal species in a measured area. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). This information does not include extinct or non-native species. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Primary mammal species range-map data used to create the diversity maps on BiodiversityMapping.org are from the IUCN. ",
		"source": "BiodiversityMapping.org, derived from digital distribution maps from the IUCN, 2018",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,212.4",
		"legend_units_label_single": "Number of Mammal Species",
		"legend_units_label": null,
		"listed_order": "7",
		"tile_opacity": null
	},
	{
		"datacode": "mammals_threatened_12192019",
		"datatype": "tileLayer",
		"theme": "species",
		"layerlabel": "Threatened Mammals",
		"shortdescription": "Threatened Mammals (2018).",
		"description": "Threatened in this case refers to mammals that are vulnerable, endangered, or critically endangered (IUCN). Threatened mammal species range-map data used to create the diversity maps on BiodiversityMapping.org are from the IUCN. Species richness and other metrics for the maps on the BiodiversityMapping website were calculated with ArcGIS 10.x using equal area grids (Eckert IV or Albers Equal Area Conic). In all cases, extinct species were removed, as were non-native distributions of extant species. Polygons listed with the attribute Vagrant were also removed. In cases where a species range was split into multiple subspecies, these were merged to create a range map for the full species when possible. Richness was calculated using a 10×10km or 100×100km grid, depending on the study. For each grid cell, any species that overlapped any part of the cell counted as a presence of that species. For some groups or areas, a uniform grid was not appropriate (e.g., watersheds for freshwater fish), and a decision was made on the best spatial unit to use that would maintain the highest data quality.",
		"source": "BiodiversityMapping.org, derived from digital distribution maps from the IUCN, 2018",
		"sourceurl": "https://biodiversitymapping.org/wordpress/index.php/download/",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": "1,33.6",
		"legend_units_label_single": "Number of Mammal Species",
		"legend_units_label": null,
		"listed_order": "8",
		"tile_opacity": null
	},
	{
		"datacode": "natural_earth_water",
		"datatype": "tileLayer",
		"theme": null,
		"layerlabel": "Rivers and Lakes",
		"shortdescription": "North American Rivers and Lakes.",
		"description": "North America rivers and lakes made with Natural Earth. naturalearthdata.com. 1:1 million river and lake centerlines, version 3.0.0 accessed June 2017. ",
		"source": null,
		"sourceurl": "http://www.naturalearthdata.com",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "orangutan_2017_02132020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Orangutan Distribution",
		"shortdescription": "Sumatran Orangutan habitat range (2017).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran orangutan (pongo abelii) is considered a critically endangered species by the IUCN with populations decreasing rapidly due to high levels of habitat conversion and fragmentation, and illegal killing. Forest loss data indicate that key Sumatran Orangutan forest habitat (i.e., below 500 m asl) was reduced by 60% of its area between 1985 and 2007 (Wich et al. 2008, 2011).",
		"source": "The IUCN Red List of Threatened Species 2017, Downloaded on 13 February 2020.",
		"sourceurl": "https://www.iucnredlist.org/species/121097935/123797627",
		"fullcitation": "Singleton, I., Wich , S.A., Nowak, M., Usher, G. & Utami-Atmoko, S.S. 2017. Pongo abelii (errata version published in 2018). The IUCN Red List of Threatened Species 2017: e.T121097935A123797627. https://dx.doi.org/10.2305/IUCN.UK.2017-3.RLTS.T121097935A115575085.en. Downloaded on 13 February 2020.",
		"fill_color": "76, 0, 115",
		"fill_opacity": "0.6",
		"stroke_color": "76, 0, 115",
		"stroke_weight": "0.4",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "soil_carbon_02132020",
		"datatype": "tileLayer",
		"theme": "carbon",
		"layerlabel": "Soil Organic Carbon Stock",
		"shortdescription": "Soil organic carbon stock (2017).",
		"description": "This dataset identifies soil organic carbon stock in the topsoil (0-30 cm depth). Soil organic carbon represents all the non-living organic compounds in soil. Plants use the organic carbon in soil as they grow. In turn, they return carbon to the soil after they die. High levels of organic soil carbon do not necessarily represent areas with lush vegetation, however. For example, in tropical rainforests, the highly active vegetation on the surface extracts most soil carbon, so those areas have especially low soil carbon. Areas where vegetation grows more slowly, especially swamps and wetlands, therefore have higher soil carbon. The measure is especially important because it plays a key role in the carbon cycle and overall climate stability. ",
		"source": "Hengl T, Mendes de Jesus J, Heuvelink GBM, Ruiperez Gonzalez M, Kilibarda M, Blagotic A, et al. (2017) SoilGrids250m: Global gridded soil information based on machine learning. PLoS ONE 12(2): e0169748. doi:10.1371/journal.pone.0169748. Accessed through ISRIC on 3/10//2020. ",
		"sourceurl": "https://data.isric.org/geonetwork/srv/eng/catalog.search;jsessionid=550B877481DF5AD3F7745DC7068880E6#/metadata/ea80098c-bb18-44d8-84dc-a8a1fbadc061",
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "0,400",
		"legend_units_label_single": "tons / ha",
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "temperate_rainforest",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Temperate Rainforest Extent",
		"shortdescription": "Temperate and perhumid boreal forests of the world.",
		"description": "This data layer includes Temperate Rainforest extent of the Pacific Coast North America, inland Northwestern North America, Chile and Argentina, Japan and Australasia. It also includes Relict Temperate, Perhumid boreal and hemiboreal forests in Europe, Eastern Canada, and the Eastern side of the Korean Peninsula. This data layer was created by Henrik vonWehrden using the Maxent model for the book, DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp.",
		"source": "Henrik vonWehrden in DellaSala, DA editor. 2010. Temperate and Boreal Rainforests of the World. Island Press, Washington DC. 336 pp. Accessed March 26, 2015 through DataBasin. ",
		"sourceurl": "http://databasin.org/maps/96307c4ce4284ad99ba3dee3be506492 ",
		"fullcitation": null,
		"fill_color": "85, 255, 0",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "7",
		"tile_opacity": null
	},
	{
		"datacode": "tiger_iucn_2015_02132020",
		"datatype": "geojson",
		"theme": "species",
		"layerlabel": "Tiger Distribution",
		"shortdescription": "Tiger Conservation Landscapes (2014).",
		"description": "Canopy selected key species in Indonesia whose habitat or ranges overlapped with other globally endangered and wide-ranging forest megafauna, according to the IUCN (International Union for the Conservation of Nature). The Sumatran tiger (panthera tigris sumatrae) is a rare tiger subspecies that inhabits the Indonesian island of Sumatra. It was listed as Critically Endangered on the IUCN Red List in 2008 as the population was estimated at 441 to 679 individuals, with no subpopulation larger than 50 individuals and a declining trend. Tigers need large contiguous forest blocks to thrive. A Tiger Conservation Landscape (TCL) is a block or cluster of blocks of habitat meeting a minimum-size threshold specific to habitat type, where tigers have been confirmed in the last 10 years and are not known to have been extirpated. Classes I - IV were included.",
		"source": "The IUCN Red List of Threatened Species 2015, Downloaded on 13 February 2020.",
		"sourceurl": "https://www.iucnredlist.org/species/15955/50659951",
		"fullcitation": "Goodrich, J., Lynam, A., Miquelle, D., Wibisono, H., Kawanishi, K., Pattanavibool, A., Htun, S., Tempa, T., Karki, J., Jhala, Y. & Karanth, U. 2015. Panthera tigris . The IUCN Red List of Threatened Species 2015: e.T15955A50659951. https://dx.doi.org/10.2305/IUCN.UK.2015-2.RLTS.T15955A50659951.en. Downloaded on 13 February 2020.",
		"fill_color": "242, 92,17",
		"fill_opacity": "0.6",
		"stroke_color": "168, 56, 0",
		"stroke_weight": "0.1",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "treecov_12112019",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Tree Cover",
		"shortdescription": "Identifies areas of tree cover for the year 2010.",
		"description": "Identifies areas of tree cover for the year 2010. At 30x30 m resolution tree cover was defined as all vegetation taller than five meters in height. Tree cover is the biophysical presence of trees and may take the form of natural forests or plantations existing over a range of canopy densities. Tip: Click on both the Tree Cover and Tree Loss layers to have a better view of the changes that occurred within that period.",
		"source": "Hansen/UMD/Google/USGS/NASA, accessed through: Global Land Analysis & Discovery on November 21, 2019",
		"sourceurl": "https://glad.umd.edu/dataset/global-2010-tree-cover-30-m",
		"fullcitation": "Hansen, M.C., Potapov, P.V., Moore, R., Hancher, M., Turubanova, S.A., Tyukavina, A., Thau, D., Stehman, S.V., Goetz, S.J., Loveland, T.R., Kommareddy, A., Egorov, A., Chini, L., Justice, C.O., and Townshend, J.R.G., 2013, High-Resolution Global Maps of 21st-Century Forest Cover Change: Science, v. 342, no. 6160, p. 850-853, at\nhttp://www.sciencemag.org/content/342/6160/850.abstract.",
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": "0, 100",
		"legend_units_label_single": null,
		"legend_units_label": "%",
		"listed_order": "3",
		"tile_opacity": null
	},
	{
		"datacode": "treeloss_12112019",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Tree Loss (2000 - 2018)",
		"shortdescription": "Areas of tree cover loss (2000 - 2018).",
		"description": "\"Tree cover\" is defined as all vegetation greater than five meters in height, and may take the form of natural forests or plantations across a range of canopy densities. \"Loss\" indicates the removal or mortality of tree cover and can be due to a variety of factors, including mechanical harvesting, fire, disease, or storm damage. As such, \"loss\" does not always equate to deforestation. Tip: Click on both the Tree Cover and Tree Loss layers to have a better view of the changes that occurred within that period.",
		"source": "2000 - 2018, Hansen/UMD/Google/USGS/NASA, Accessed through Google Earth Engine Partners on November 15, 2019",
		"sourceurl": "https://earthenginepartners.appspot.com/science-2013-global-forest/download_v1.6.html",
		"fullcitation": "Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from: http://earthenginepartners.appspot.com/science-2013-global-forest.",
		"fill_color": "239, 59, 44",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "4",
		"tile_opacity": null
	},
	{
		"datacode": "vancouver_island",
		"datatype": "geojson",
		"theme": "landscapes",
		"layerlabel": "Vancouver Island Boundary",
		"shortdescription": "Vancouver Island, British Columbia, Canada.",
		"description": "Vancouver Island has some of the richest temperate rainforests on Earth, but has lost up to 90% of the largest old-growth rainforests to logging and development. These remaining pockets of old-growth forest contain important species habitat, and play a critical role in stabilizing the Earth's climate through carbon storage. This Vancouver Island boundary is derived from ESRI Global country boundaries with a 5km buffer.",
		"source": "Accessed through ArcGIS Online, October 18, 2017. ",
		"sourceurl": "https://www.arcgis.com/home/item.html?id=2ca75003ef9d477fb22db19832c9554f ",
		"fullcitation": null,
		"fill_color": "255, 255, 115",
		"fill_opacity": "0.6",
		"stroke_color": "230, 153, 0",
		"stroke_weight": "1.5",
		"stroke_opacity": "1",
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "yes",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "1",
		"tile_opacity": null
	},
	{
		"datacode": "vancouver_island_marker",
		"datatype": "marker",
		"theme": "earth engine map marker",
		"layerlabel": "vancouver_island_marker",
		"shortdescription": null,
		"description": null,
		"source": null,
		"sourceurl": null,
		"fullcitation": null,
		"fill_color": null,
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "no",
		"marker_style": "default",
		"marker_lat_lng": "48.72306,-124.12302",
		"story_map": "yes",
		"expert_map": null,
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": null,
		"tile_opacity": null
	},
	{
		"datacode": "wwf_deforestation_fronts_02122020",
		"datatype": "tileLayer",
		"theme": "forests",
		"layerlabel": "Global Deforestation Fronts",
		"shortdescription": "Likely deforestation locations from 2010 to 2030.",
		"description": "Most of the deforestation from 2010 until 2030 will likely happen in 11 deforestation fronts, places that will account for over 80 per cent of the forest loss projected globally by 2030. These fronts, ten of which are in the tropics, are where efforts to halt deforestation must be concentrated.",
		"source": "WWF Global Observation and Biodiversity Information Portal (GLOBIL), Created: March 30, 2015, Updated: February 5, 2020, Accessed on January 6, 2020.",
		"sourceurl": "https://panda.maps.arcgis.com/home/item.html?id=e7415ab9256949e4994f711a99cac758",
		"fullcitation": null,
		"fill_color": "198, 41, 66",
		"fill_opacity": null,
		"stroke_color": null,
		"stroke_weight": null,
		"stroke_opacity": null,
		"display_legend": "yes",
		"marker_style": null,
		"marker_lat_lng": null,
		"story_map": "no",
		"expert_map": "yes",
		"legend_units": null,
		"legend_units_label_single": null,
		"legend_units_label": null,
		"listed_order": "8",
		"tile_opacity": null
	}
];

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_MAP_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DESELECT_MAP_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DESELECT_ALL_MAP_LAYERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ZOOM_TO_MAP_LAYER_EXTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ZOOM_TO_MAP_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_BASEMAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GEOJSON_LAYER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GEOJSON_LAYER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GEOJSON_LAYER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECT_LAYERS_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SIDEBAR_EXPAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SIDEBAR_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIGHTBOX_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIGHTBOX_CLOSE; });
var SELECT_MAP_LAYER = 'SELECT_MAP_LAYER';
var DESELECT_MAP_LAYER = 'DESELECT_MAP_LAYER';
var DESELECT_ALL_MAP_LAYERS = 'DESELECT_ALL_MAP_LAYERS';

var ZOOM_TO_MAP_LAYER_EXTENT = 'ZOOM_TO_MAP_LAYER_EXTENT';
var ZOOM_TO_MAP_HOME = 'ZOOM_TO_MAP_HOME';

var TOGGLE_BASEMAP = 'TOGGLE_BASEMAP';

var GEOJSON_LAYER_REQUEST = 'GEOJSON_LAYER_REQUEST';
var GEOJSON_LAYER_SUCCESS = 'GEOJSON_LAYER_SUCCESS';
var GEOJSON_LAYER_ERROR = 'GEOJSON_LAYER_ERROR';

var SELECT_LAYERS_TAB = 'SELECT_LAYERS_TAB';
var SIDEBAR_EXPAND = 'SIDEBAR_EXPAND';
var SIDEBAR_COLLAPSE = 'SIDEBAR_COLLAPSE';

var LIGHTBOX_OPEN = 'LIGHTBOX_OPEN';
var LIGHTBOX_CLOSE = 'LIGHTBOX_CLOSE';
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SELECT_MAP_LAYER, 'SELECT_MAP_LAYER', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(DESELECT_MAP_LAYER, 'DESELECT_MAP_LAYER', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(DESELECT_ALL_MAP_LAYERS, 'DESELECT_ALL_MAP_LAYERS', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(ZOOM_TO_MAP_LAYER_EXTENT, 'ZOOM_TO_MAP_LAYER_EXTENT', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(ZOOM_TO_MAP_HOME, 'ZOOM_TO_MAP_HOME', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(TOGGLE_BASEMAP, 'TOGGLE_BASEMAP', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(GEOJSON_LAYER_REQUEST, 'GEOJSON_LAYER_REQUEST', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(GEOJSON_LAYER_SUCCESS, 'GEOJSON_LAYER_SUCCESS', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(GEOJSON_LAYER_ERROR, 'GEOJSON_LAYER_ERROR', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(SELECT_LAYERS_TAB, 'SELECT_LAYERS_TAB', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(SIDEBAR_EXPAND, 'SIDEBAR_EXPAND', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(SIDEBAR_COLLAPSE, 'SIDEBAR_COLLAPSE', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(LIGHTBOX_OPEN, 'LIGHTBOX_OPEN', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');

  __REACT_HOT_LOADER__.register(LIGHTBOX_CLOSE, 'LIGHTBOX_CLOSE', '/Users/gin/ginfo/canopyplanet_expert_map/src/common/actionTypes.js');
}();

;

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["f"]; });
/* unused harmony reexport zoomToMapHome */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__mapLayersActions__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebarActions__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sidebarActions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sidebarActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sidebarActions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lightboxActions__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__lightboxActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__lightboxActions__["b"]; });







;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ })

},[315]);


// WEBPACK FOOTER //
// bundle.f0dde43eff3e6c937cc2.js